import {Component, OnInit, TemplateRef, ViewChild, inject} from '@angular/core';
import {VtnGenericaComponent} from '../../util/ventanas/vtn-generica/vtn-generica.component';
import {ClsUtil} from '../../../util/cls-util';
import {AppPresupuestosService} from '../../../core/services/app-presupuestos.service';
import {ClsConfig} from '../../../util/cls-config';
import {EnumParaOrg, EnumParaPpto} from '../../../core/models/enum/enum-parametros';
import {TresPuntosComponent} from '../../util/controles/tres-puntos/tres-puntos.component';
import { IChangeCheckboxEventArgs } from '@infragistics/igniteui-angular/checkbox';
import { IGX_GRID_DIRECTIVES, IgxGridComponent, IgxGridModule } from '@infragistics/igniteui-angular/grids/grid';
import {
  IGX_INPUT_GROUP_DIRECTIVES,
  IgxInputDirective,
  IgxInputGroupComponent
} from '@infragistics/igniteui-angular/input-group';
import {
  IGX_TABS_DIRECTIVES,
  IgxTabsComponent,
  IgxTabsModule,
  ITabsSelectedIndexChangingEventArgs
} from '@infragistics/igniteui-angular/tabs';
import { IgxButtonDirective, IgxButtonModule, IgxDividerModule, IgxLayoutModule, IgxRippleDirective, IgxRippleModule, IgxTextSelectionDirective } from '@infragistics/igniteui-angular/directives';
import { IgxIconComponent } from '@infragistics/igniteui-angular/icon';
import { IGX_CARD_DIRECTIVES, IgxCardModule } from '@infragistics/igniteui-angular/card';
import {
  IGX_RADIO_GROUP_DIRECTIVES,
  IgxRadioComponent,
  IgxRadioGroupDirective
} from '@infragistics/igniteui-angular/radio';
import { IGX_ACTION_STRIP_DIRECTIVES, IgxActionStripModule } from '@infragistics/igniteui-angular/action-strip';
import { IGridEditDoneEventArgs, IGridEditEventArgs } from '@infragistics/igniteui-angular/grids/core';
import {ClsObjGenerico} from '../../../clases-pu/util/cls-obj-generico';
import {AppInfoService} from '../../../core/services/app-info.service';
import {ListaDocumentosComponent} from '../../util/ventanas/lista-documentos/lista-documentos.component';
import {ClsObjCostoHorario} from '../../../clases-pu/01-presupuesto/presupuesto/cls-obj-costo-horario';
import {IgxExcelModule, Workbook, Worksheet} from 'igniteui-angular-excel';
import {
  IgxSpreadsheetComponent,
  SpreadsheetCell,
  IgxSpreadsheetModule
} from 'igniteui-angular-spreadsheet';
import {
  ClsObjExplosionDeInsumos
} from '../../../clases-pu/01-presupuesto/menu-presupuesto/cls-obj-explosion-de-insumos';
import {ClsObjMatrices} from '../../../clases-pu/01-presupuesto/matrices/cls-obj-matrices';
import {ClsObjCatalogoPresupuestosGenerales} from '../../../clases-pu/cls-obj-catalogo-presupuestos-generales';
import {ExcelUtility} from '../../../util/excel-utility';
import {EnumTipoParametro} from '../../../core/models/enum/enum-tipo-parametro';
import {BusquedaLibroComponent} from '../../util/controles/busqueda-libro/busqueda-libro.component';
import {ClsObjParametrosPorOrganizacion} from '../../../clases-pu/util/cls-obj-parametros-por-organizacion';
import {ClsObjParametrosPorPpto} from '../../../clases-pu/util/cls-obj-parametros-por-ppto';
import {EnumSocket} from '../../../core/models/enum/enum-socket';
import {SocketService} from '../../../core/services/socket.service';
import {TranslateModule} from '@ngx-translate/core';
import {FormsModule} from '@angular/forms';
import {SelectMonedaComponent} from '../../util/controles/select-moneda/select-moneda.component';
import {ClsDetalleMatrizInsumos} from 'src/app/core/models/cls-matriz';
import {ClsCatalogosExpIns} from 'src/app/core/models/cls-catalogo-general';
import {ClsListaArchivos} from "../../../core/models/cls-storage";
import {
  ClsCostoHorarios,
  ClsLsJsonCostosHorariosMO,
  ClsLsJsonCostosHorariosOC
} from "../../../core/models/cls-costo-horarios";
import {ClsParametro} from "../../../core/models/cls-parametros";
import {EnumPosicionBtn} from "../../../core/models/enum/enum-mas-opciones";
import {INeodataBtnsFooter} from "../../../core/models/interfaces/generico-interface";
import {EnumTipoTresPuntos} from 'src/app/core/models/enum/enum-costos-horarios';
import {TipoMensajesService} from "../../../core/services/tipo-mensajes.service";
import {SummaryPipeNeoPipe} from "../../../core/pipes/summary-pipe-neo.pipe";
import {setTimeout} from "worker-timers";
import {EnumShortCuts} from "../../../core/models/enum/enum-short-cuts";
import {Subscription} from "rxjs";
import {ShortcutsBusService} from "../../../core/services/shortcuts-bus.service";
import {EnumTresPuntos} from "../../../core/models/enum/enum-tres-puntos";

@Component({
  selector: 'app-costo-horario',
  templateUrl: './costo-horario.component.html',
  styleUrls: ['./costo-horario.component.scss'],
  imports: [
    IgxLayoutModule,
    TranslateModule,
    BusquedaLibroComponent,
    SelectMonedaComponent,
    IgxTabsModule,
    IGX_TABS_DIRECTIVES,
    IGX_INPUT_GROUP_DIRECTIVES,
    TresPuntosComponent,
    IgxTextSelectionDirective,
    IgxCardModule,
    IGX_CARD_DIRECTIVES,
    IGX_RADIO_GROUP_DIRECTIVES,
    FormsModule,
    IgxDividerModule,
    IgxGridModule,
    IGX_GRID_DIRECTIVES,
    IgxButtonModule,
    IgxButtonDirective,
    IgxRippleModule,
    IgxRippleDirective,
    IgxIconComponent,
    IgxActionStripModule,
    IGX_ACTION_STRIP_DIRECTIVES,
    IgxSpreadsheetModule,
    IgxExcelModule,
    SummaryPipeNeoPipe,
    IgxInputGroupComponent,
    IgxRadioGroupDirective,
    IgxRadioComponent,
  ]
})
export class CostoHorarioComponent extends ClsConfig implements OnInit {
  private infPpto = inject(AppPresupuestosService);
  private infApp = inject(AppInfoService);
  private socket = inject(SocketService);
  private tipoMsg = inject(TipoMensajesService);
  public shortcutsBus = inject(ShortcutsBusService);

  @ViewChild('selectMonedas', {read: SelectMonedaComponent, static: true})
  public selectMonedas: SelectMonedaComponent;

  @ViewChild('busquedaLibroCH', {static: true})
  public busquedaLibroCH: BusquedaLibroComponent;

  @ViewChild('spreadsheet', {read: IgxSpreadsheetComponent, static: true})
  public spreadsheet: IgxSpreadsheetComponent;

  @ViewChild('tabGeneral', {static: true})
  public tabGeneral: IgxTabsComponent;

  @ViewChild('tresPuntosCFA', {read: TresPuntosComponent, static: true})
  public tresPuntosCFA: TresPuntosComponent;
  @ViewChild('desCFA', {read: IgxInputDirective, static: true})
  public desCFA: IgxInputDirective;
  @ViewChild('tresPuntosUniCFA', {read: TresPuntosComponent, static: true})
  public tresPuntosUniCFA: TresPuntosComponent;
  @ViewChild('costoCFA', {read: IgxInputDirective, static: true})
  public costoCFA: IgxInputDirective;
  @ViewChild('tresPuntosEspera', {read: TresPuntosComponent, static: true})
  public tresPuntosEspera: TresPuntosComponent;
  @ViewChild('desEspera', {read: IgxInputDirective, static: true})
  public desEspera: IgxInputDirective;
  @ViewChild('tresPuntosUniEspera', {read: TresPuntosComponent, static: true})
  public tresPuntosUniEspera: TresPuntosComponent;
  @ViewChild('costoEspera', {read: IgxInputDirective, static: true})
  public costoEspera: IgxInputDirective;
  @ViewChild('tresPuntosReserva', {read: TresPuntosComponent, static: true})
  public tresPuntosReserva: TresPuntosComponent;
  @ViewChild('desReserva', {read: IgxInputDirective, static: true})
  public desReserva: IgxInputDirective;
  @ViewChild('tresPuntosUniReserva', {read: TresPuntosComponent, static: true})
  public tresPuntosUniReserva: TresPuntosComponent;
  @ViewChild('costoReserva', {read: IgxInputDirective, static: true})
  public costoReserva: IgxInputDirective;
  @ViewChild('tresPuntosValorAdq', {read: TresPuntosComponent, static: true})
  public tresPuntosValorAdq: TresPuntosComponent;
  @ViewChild('desValorAdq', {read: IgxInputDirective, static: true})
  public desValorAdq: IgxInputDirective;
  @ViewChild('tresPuntosUniValorAdq', {read: TresPuntosComponent, static: true})
  public tresPuntosUniValorAdq: TresPuntosComponent;
  @ViewChild('costoValorAdq', {read: IgxInputDirective, static: true})
  public costoValorAdq: IgxInputDirective;
  @ViewChild('tresPuntosLlantas', {read: TresPuntosComponent, static: true})
  public tresPuntosLlantas: TresPuntosComponent;
  @ViewChild('desLlantas', {read: IgxInputDirective, static: true})
  public desLlantas: IgxInputDirective;
  @ViewChild('tresPuntosUniLlantas', {read: TresPuntosComponent, static: true})
  public tresPuntosUniLlantas: TresPuntosComponent;
  @ViewChild('costoLlantas', {read: IgxInputDirective, static: true})
  public costoLlantas: IgxInputDirective;
  @ViewChild('tresPuntosPzaEsp', {read: TresPuntosComponent, static: true})
  public tresPuntosPzaEsp: TresPuntosComponent;
  @ViewChild('desPzaEsp', {read: IgxInputDirective, static: true})
  public desPzaEsp: IgxInputDirective;
  @ViewChild('tresPuntosUniPzaEsp', {read: TresPuntosComponent, static: true})
  public tresPuntosUniPzaEsp: TresPuntosComponent;
  @ViewChild('costoPzaEsp', {read: IgxInputDirective, static: true})
  public costoPzaEsp: IgxInputDirective;
  @ViewChild('tresPuntosCombustible', {read: TresPuntosComponent, static: true})
  public tresPuntosCombustible: TresPuntosComponent;
  @ViewChild('desCombustible', {read: IgxInputDirective, static: true})
  public desCombustible: IgxInputDirective;
  @ViewChild('tresPuntosUniCombustible', {read: TresPuntosComponent, static: true})
  public tresPuntosUniCombustible: TresPuntosComponent;
  @ViewChild('costoCombustible', {read: IgxInputDirective, static: true})
  public costoCombustible: IgxInputDirective;
  @ViewChild('tresPuntosLubricante', {read: TresPuntosComponent, static: true})
  public tresPuntosLubricante: TresPuntosComponent;
  @ViewChild('desLubricante', {read: IgxInputDirective, static: true})
  public desLubricante: IgxInputDirective;
  @ViewChild('tresPuntosUniLubricante', {read: TresPuntosComponent, static: true})
  public tresPuntosUniLubricante: TresPuntosComponent;
  @ViewChild('costoLubricante', {read: IgxInputDirective, static: true})
  public costoLubricante: IgxInputDirective;
  @ViewChild('tresPuntosOtrasFEnergia', {read: TresPuntosComponent, static: true})
  public tresPuntosOtrasFEnergia: TresPuntosComponent;
  @ViewChild('desOtrasFEnergia', {read: IgxInputDirective, static: true})
  public desOtrasFEnergia: IgxInputDirective;
  @ViewChild('tresPuntosUniOtrasFEnergia', {read: TresPuntosComponent, static: true})
  public tresPuntosUniOtrasFEnergia: TresPuntosComponent;
  @ViewChild('costoOtrasFEnergia', {read: IgxInputDirective, static: true})
  public costoOtrasFEnergia: IgxInputDirective;

  @ViewChild('vidaEconomicaHrsLlantas', {read: IgxInputDirective, static: true})
  public vidaEconomicaHrsLlantas: IgxInputDirective;
  @ViewChild('vidaEconomicaHrsPzaEsp', {read: IgxInputDirective, static: true})
  public vidaEconomicaHrsPzaEsp: IgxInputDirective;
  @ViewChild('valorMaquinaria', {read: IgxInputDirective, static: true})
  public valorMaquinaria: IgxInputDirective;

  // tab cargo fijo
  @ViewChild('cfVidaEconomicaHrs', {read: IgxInputDirective, static: true})
  public cfVidaEconomicaHrs: IgxInputDirective;
  @ViewChild('hrsTrabajadasXAnio', {read: IgxInputDirective, static: true})
  public hrsTrabajadasXAnio: IgxInputDirective;
  @ViewChild('valorRescatePor', {read: IgxInputDirective, static: true})
  public valorRescatePor: IgxInputDirective;
  @ViewChild('tasaInteres', {read: IgxInputDirective, static: true})
  public tasaInteres: IgxInputDirective;
  @ViewChild('primaAnualProSeg', {read: IgxInputDirective, static: true})
  public primaAnualProSeg: IgxInputDirective;
  @ViewChild('factorMantenimiento', {read: IgxInputDirective, static: true})
  public factorMantenimiento: IgxInputDirective;
  @ViewChild('depreciacion', {read: IgxInputDirective, static: true})
  public depreciacion: IgxInputDirective;
  @ViewChild('inversion', {read: IgxInputDirective, static: true})
  public inversion: IgxInputDirective;
  @ViewChild('seguro', {read: IgxInputDirective, static: true})
  public seguro: IgxInputDirective;
  @ViewChild('mantenimiento', {read: IgxInputDirective, static: true})
  public mantenimiento: IgxInputDirective;
  @ViewChild('totalCF', {read: IgxInputDirective, static: true})
  public totalCF: IgxInputDirective;

  // tab consumos
  public rTipoLubCom: any;
  @ViewChild('potenciaDescripcion', {read: IgxInputDirective, static: true})
  public potenciaDescripcion: IgxInputDirective;
  @ViewChild('potenciaValor', {read: IgxInputDirective, static: true})
  public potenciaValor: IgxInputDirective;
  @ViewChild('factorOperacionPor', {read: IgxInputDirective, static: true})
  public factorOperacionPor: IgxInputDirective;
  @ViewChild('potenciaOpeTotal', {read: IgxInputDirective, static: true})
  public potenciaOpeTotal: IgxInputDirective;
  public rCombustible: any;
  @ViewChild('combustibleXHora', {read: IgxInputDirective, static: true})
  public combustibleXHora: IgxInputDirective;
  @ViewChild('factorCombustible', {read: IgxInputDirective, static: true})
  public factorCombustible: IgxInputDirective;
  @ViewChild('consumoLts', {read: IgxInputDirective, static: true})
  public consumoLts: IgxInputDirective;
  @ViewChild('factorOtrasFuentes', {read: IgxInputDirective, static: true})
  public factorOtrasFuentes: IgxInputDirective;
  @ViewChild('lubricanteXHora', {read: IgxInputDirective, static: true})
  public lubricanteXHora: IgxInputDirective;
  @ViewChild('factorLubricante', {read: IgxInputDirective, static: true})
  public factorLubricante: IgxInputDirective;
  @ViewChild('carterLts', {read: IgxInputDirective, static: true})
  public carterLts: IgxInputDirective;
  @ViewChild('hrsCambio', {read: IgxInputDirective, static: true})
  public hrsCambio: IgxInputDirective;
  @ViewChild('totalLubricante', {read: IgxInputDirective, static: true})
  public totalLubricante: IgxInputDirective;

  // tab operacion
  @ViewChild('gridOperacion', {read: IgxGridComponent, static: true})
  public gridOperacion: IgxGridComponent;
  public mRowDataOperacion: ClsDetalleMatrizInsumos;
  @ViewChild('tresPuntosCodigoOperacion', {read: TresPuntosComponent, static: true})
  public tresPuntosCodigoOperacion: TresPuntosComponent;
  @ViewChild('tresPuntosUnidadOperacion', {read: TresPuntosComponent, static: true})
  public tresPuntosUnidadOperacion: TresPuntosComponent;
  // tab otros consumos
  @ViewChild('gridOtrosConsumos', {read: IgxGridComponent, static: true})
  public gridOtrosConsumos: IgxGridComponent;
  public mRowDataOtrosConsumos: ClsDetalleMatrizInsumos;
  @ViewChild('tresPuntosCodigoOtroCons', {read: TresPuntosComponent, static: true})
  public tresPuntosCodigoOtroCons: TresPuntosComponent;
  @ViewChild('tresPuntosUnidadOtroCons', {read: TresPuntosComponent, static: true})
  public tresPuntosUnidadOtroCons: TresPuntosComponent;
  // detalle
  @ViewChild('marca', {read: IgxInputDirective, static: true})
  public marca: IgxInputDirective;
  @ViewChild('modelo', {read: IgxInputDirective, static: true})
  public modelo: IgxInputDirective;
  @ViewChild('numeroSerie', {read: IgxInputDirective, static: true})
  public numeroSerie: IgxInputDirective;
  @ViewChild('capacidad', {read: IgxInputDirective, static: true})
  public capacidad: IgxInputDirective;
  @ViewChild('ubicacion', {read: IgxInputDirective, static: true})
  public ubicacion: IgxInputDirective;
  @ViewChild('vidaUtil', {read: IgxInputDirective, static: true})
  public vidaUtil: IgxInputDirective;
  @ViewChild('propietario', {read: IgxInputDirective, static: true})
  public propietario: IgxInputDirective;
  public rDisponibilidad: any;
  // totales CH
  @ViewChild('ttotalCF', {read: IgxInputDirective, static: true})
  public ttotalCF: IgxInputDirective;
  @ViewChild('ttotalOperacion', {read: IgxInputDirective, static: true})
  public ttotalOperacion: IgxInputDirective;
  @ViewChild('ttotalConsumos', {read: IgxInputDirective, static: true})
  public ttotalConsumos: IgxInputDirective;
  @ViewChild('ttotalCostoActivo', {read: IgxInputDirective, static: true})
  public ttotalCostoActivo: IgxInputDirective;
  @ViewChild('ttotalCostoEspera', {read: IgxInputDirective, static: true})
  public ttotalCostoEspera: IgxInputDirective;
  @ViewChild('ttotalCostoReserva', {read: IgxInputDirective, static: true})
  public ttotalCostoReserva: IgxInputDirective;
  // obj de catalogo de obras
  public expInsCF: ClsCatalogosExpIns;
  public expInsE: ClsCatalogosExpIns;
  public expInsR: ClsCatalogosExpIns;
  public expInsVA: ClsCatalogosExpIns;
  public expInsLl: ClsCatalogosExpIns;
  public expInsPE: ClsCatalogosExpIns;
  public expInsC: ClsCatalogosExpIns;
  public expInsL: ClsCatalogosExpIns;
  public expInsOFE: ClsCatalogosExpIns;
  // resto de variables
  public titulo: string;
  private docSelec: ClsListaArchivos;
  private contenidoDocCH: string;
  private nombreDoc: string;
  public esMoneda1: boolean;
  public filaSeleccionado: any;
  public dataOperaciones: ClsDetalleMatrizInsumos[] = [];
  public dataOtrosConsumos: ClsDetalleMatrizInsumos[] = [];
  public esMaestro = false;
  public mFactorCombustible = -1;
  public mObjCostoHorario: ClsCostoHorarios;
  // mostrar actionStrip
  public showActionStripOperacion = true;
  public showActionStripOtrosConsumos = true;
  // hojas libro CH
  public mHojaCamposGenerales: Worksheet;
  public mHojaDatos: Worksheet;
  public mHojaCalculo: Worksheet;
  // vtn generico
  public vtnGenerico: VtnGenericaComponent;
  // OBJ
  private mObjGenerico: ClsObjGenerico = new ClsObjGenerico();
  private mObjCH: ClsObjCostoHorario = new ClsObjCostoHorario();
  private mObjExpInsumos: ClsObjExplosionDeInsumos = new ClsObjExplosionDeInsumos();
  private mObjMatrices: ClsObjMatrices = new ClsObjMatrices();
  private mObjCatalogoPptosGrals: ClsObjCatalogoPresupuestosGenerales = new ClsObjCatalogoPresupuestosGenerales();
  private mObjParamOrg: ClsObjParametrosPorOrganizacion = new ClsObjParametrosPorOrganizacion();
  private mObjParamPpto: ClsObjParametrosPorPpto = new ClsObjParametrosPorPpto();
  // CONFIGGRIDS: definir cada ng-Template que tengamos en el HTML
  @ViewChild('codigoEditorTemplate', {static: true}) public codigoEditorTemplate: TemplateRef<any>;
  @ViewChild('unidadEditorTemplate', {static: true}) public unidadEditorTemplate: TemplateRef<any>;

  private sub!: Subscription;
  constructor() {
    super();
    this.mObjCH.mObjGenerico = this.mObjGenerico;
  }

  ngOnInit(): void {
    this.sub = this.shortcutsBus.action$.subscribe(async (action: string) => {
      switch (action) {
        case EnumShortCuts.DESHACER:
          switch (this.tabGeneral.selectedIndex) {
            case 3: // CHOPERACION
              this.undoOperacion();
              break;
            case 4: // CHCONSUMOS
              this.undoOtrosCons();
              break;
          }
          break;
        case EnumShortCuts.REHACER:
          switch (this.tabGeneral.selectedIndex) {
            case 3: // CHOPERACION
              this.redoOperacion();
              break;
            case 4: // CHCONSUMOS
              this.redoOtrosCons();
              break;
          }
          break;
        case EnumShortCuts.GUARDAR:
          switch (this.tabGeneral.selectedIndex) {
            case 3: // CHOPERACION
              await this.commitOperacion(true);
              break;
            case 4: // CHCONSUMOS
              await this.commitOtrosCons(true);
              break;
          }
          break;
        case EnumShortCuts.DESCARTAR:
          switch (this.tabGeneral.selectedIndex) {
            case 3: // CHOPERACION
              this.discardOperacion();
              break;
            case 4: // CHCONSUMOS
              this.discardOtrosCons();
              break;
          }
          break;
      }
    });
    // EVENTO DE BOTONES VENTANA
    this.vtnGenerico.evtBoton.subscribe(async (btn: INeodataBtnsFooter) => {
      switch (btn.id) {
        case 'ACEPTAR':
          await this.guardarInf();
          break;
        default: // cancelar
          this.validarAntesCerrar();
      }
    });
    this.vtnGenerico.evtCerrarVnt.subscribe(() => {
      this.validarAntesCerrar();
    });
    this.busquedaLibroCH.evtSubirArchivo.subscribe(async (evt: any) => {
      try {
        this.tipoMsg.mostrarWaitDialog('MENSAJES.GRALS.CARGANDO');
        const archivo: File = evt.target.files[0];
        if (ClsUtil.validarExtensionesArchivo(archivo.name, this.mObjGenerico, ['xlsx', 'xls'])) {
          this.docSelec = await this.mObjCH.inicializarValidarDatosSubirArchivoLocal(archivo, this.gPrefixMoneda1);
          this.busquedaLibroCH.valorInput = this.docSelec.Documento;
          await this.recargaHojaSeleccionada();
        }
      } catch (e) {
        this.tipoMsg.mostrarMsg(e.message, 'error');
      } finally {
        evt.target.value = [];
        this.tipoMsg.cerrarWaitDialog();
      }
    });
    this.busquedaLibroCH.evtBajarArchivo.subscribe(async () => {
      await this.descagarArchivoLocal();
    });
    this.busquedaLibroCH.evtObtenerListadoLibro.subscribe(async () => {
      try {
        this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.GET_DATOS');
        let listaCH: ClsListaArchivos[] = await this.mObjGenerico.obtenerListadoArchivosStorage(this.gNomBocketCH, this.gNomPrefixNeodata);
        listaCH = ClsUtil.reemplazarInfoArchivosStorage(listaCH, 'Costo Horario', `${this.gNomPrefixNeodata}/`);
        const vtnListadoDoc: ListaDocumentosComponent = this.mObjGenerico.inicializarVtnDocumentos(listaCH);
        vtnListadoDoc.documentoSeleccionado.subscribe(async (doc: ClsListaArchivos) => {
          try {
            this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.DESCARGANDO_DOC');
            this.docSelec = await ClsUtil.descargarArchivoCargarVnt('', this.gPrefixMoneda1, doc.Documento + doc.Extension, this.gNomBocketCH, this.gNomPrefixNeodata, this.gNomPrefixPptoCH, this.mObjGenerico);
            await this.recargaHojaSeleccionada();
          } catch (e) {
            this.tipoMsg.mostrarMsg(e.message, 'error');
          } finally {
            this.tipoMsg.cerrarWaitDialog();
          }
        });
      } catch (e) {
        this.tipoMsg.mostrarMsg(e.message, 'error');
      } finally {
        this.tipoMsg.cerrarWaitDialog();
      }
    });
  }

  public async open() {
    this.titulo = `${this.mObjGenerico.getTranslationsSubject('MENSAJES.GRALS.CH')}: ${this.filaSeleccionado.Codigo} - ${this.filaSeleccionado.Unidad}`;
    this.esMaestro = this.infPpto.esPptoMaestro;
    await this.setValores();
  }

  public async handleSelection(e: any) {
    const displayText: string = e.newSelection.value;
    e.cancel = ClsUtil.esNulo(displayText);
    if (!e.cancel) {
      this.esMoneda1 = (displayText === 'PESOS');
      await this.setValoresDefault();
      this.vaciaDatosDelEquipoAExcel();
      this.vaciaCostoDetallado();
      this.vaciaOperacionAExcel();
      this.vaciaOtrosConsumosAExcel();
      this.regresaDatosExcel();
    }
  }

  private async setValores() {
    try {
      this.tipoMsg.mostrarMasMsgsCustomizado('MENSAJES.GRALS.CH');
      const idPpto: bigint = ClsUtil.getPptoSelectedActivoMaestro(this.infPpto).IdPresupuesto;
      // obtener parametros organizacion y ppto
      this.tipoMsg.actualizarMensaje2('MENSAJES.WAIT.OBTENER_PARAMETROS');
      this.infPpto.parametrosOrganizacion = await this.mObjGenerico.obtenerNParametros(this.infPpto.organizacion.IdOrganizacion, EnumTipoParametro.Organizacion, this.mObjParamOrg.getParametrosCH());
      this.infPpto.parametrosPpto = await this.mObjGenerico.obtenerNParametros(idPpto, EnumTipoParametro.Presupuesto, this.mObjParamPpto.getParametrosDefaultsPpto());
      // obtener catalogo de monedas
      await this.selectMonedas.obtenerMonedas();
      this.esMoneda1 = true;
      this.vtnGenerico.regresarEventoCerrar = true;
      const redondearImporte: string = this.infPpto.parametrosPpto.find(para => para.Parametro === EnumParaPpto.CALDECCU).Valor;
      this.formatDecImporte = {digitsInfo: ClsUtil.formatoDecimales(redondearImporte), currencyCode: 'MXN', display: 'symbol-narrow', local: ClsUtil.obtenerLocalGrid()};
      const nombreCH: string = this.infPpto.parametrosPpto.find(para => para.Parametro === EnumParaPpto.CHNOMBRELIBROCH).Valor;
      this.tipoMsg.actualizarMensaje2('MENSAJES.WAIT.DESCARGANDO_DOC');
      this.docSelec = await this.mObjCH.validarDocumentoCHDescarga(nombreCH, idPpto);
      this.contenidoDocCH = this.docSelec.ContenidoBase64;
      // obtener analisis CH
      this.mObjCostoHorario = ClsUtil.getPptoCompletoActivoMaestroJSON(this.infPpto).CostoHorarios.find(value => ClsUtil.bigintX(value.IdCatalogoCostoHorario) === ClsUtil.bigintX(this.filaSeleccionado.IdCatalogo));
      // en caso que no exista en la lista, ocupar el servicio para obtener este CH y actualizar la lista
      if (ClsUtil.esNulo(this.mObjCostoHorario) && !this.esMaestro) {
        this.tipoMsg.actualizarMensaje2('MENSAJES.WAIT.OBTENER_CH_CALCULO');
        this.mObjCostoHorario = await this.mObjCH.obtenerUnCostoHorario(ClsUtil.bigintX(this.filaSeleccionado.IdCatalogo));
        if (!ClsUtil.esNulo(this.mObjCostoHorario)) {
          this.mObjCH.actualizarListaCH(this.mObjCostoHorario);
        }
      }
      this.tipoMsg.actualizarMensaje2('MENSAJES.WAIT.VALIDANDO_INF');
      await this.recargaHojaSeleccionada();
      this.nombreDoc = this.docSelec.Documento + this.docSelec.Extension;
      this.vtnGenerico.btnsAccion = [
        {
          id: 'ACEPTAR',
          texto: 'BOTONES.ACEPTAR',
          titulo: 'BOTONES.ACEPTAR',
          icono: '',
          tipoBoton: 'contained',
          posicion: EnumPosicionBtn.DERECHO,
          hidden: this.esMaestro
        },
        {
          id: 'CANCELAR',
          texto: 'BOTONES.CANCELAR',
          titulo: 'BOTONES.CANCELAR',
          icono: '',
          tipoBoton: 'flat',
          posicion: EnumPosicionBtn.DERECHO
        }
      ];
      this.vtnGenerico.open(560, 1250, this.titulo, '');
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message);
    } finally {
      this.tipoMsg.cerrarMasMsgsCustomizado();
    }
  }

  private async recargaHojaSeleccionada() {
    try {
      this.docSelec.Workbook = await this.bloquearCargarValidarLibro(this.docSelec.ContenidoArchivoFile)
      this.spreadsheet.workbook = this.docSelec.Workbook;
      this.spreadsheet.activeWorksheet = this.spreadsheet.workbook.worksheets(this.mObjCH.IndiceHojaCalculo);
      this.busquedaLibroCH.valorInput = this.docSelec.Documento;
      //  validar si hay datos guardados en la BD para el idCatalogo seleccionado
      //  en caso de no tener, asignar valores defaults
      this.limpiarLibroDatosGenerales();
      this.limpiaLibroDatosParticulares();
      await this.enviaParametrosGenerales();
      await this.setValoresDefault();
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public cambioTab(tab: ITabsSelectedIndexChangingEventArgs) {
    if (tab.newIndex === 6) {
      if (this.validarDatosSinGuardarGrid()) {
        this.vaciaDatosDelEquipoAExcel();
        setTimeout(() => {
          this.spreadsheet.styleUpdated();
        }, 0);
      } else {
        tab.cancel = true;
      }
    }
  }

  private async setValoresDefault() {
    let costo = 0;
    const allCat: ClsCatalogosExpIns[] = ClsUtil.getPptoCompletoActivoMaestroJSON(this.infPpto).CatExpIns;
    const idPpto: bigint = ClsUtil.getPptoSelectedActivoMaestro(this.infPpto).IdPresupuesto;
    if (!ClsUtil.esNulo(this.mObjCostoHorario)) {
      const mapCatalogo: Map<bigint, any> = ClsUtil.crearMapIdCatalogo(allCat);
      this.mObjCostoHorario.IdPresupuesto = idPpto
      this.mObjCostoHorario.IdCatalogoCostoHorario = ClsUtil.bigintX(this.filaSeleccionado.IdCatalogo);
      // tab datos
      if (ClsUtil.bigintX(this.mObjCostoHorario.IdCatalogoCF) !== 0n) {
        const cf: ClsCatalogosExpIns = mapCatalogo.get(ClsUtil.bigintX(this.mObjCostoHorario.IdCatalogoCF));
        this.tresPuntosCFA.valorDefault = cf.Codigo;
        this.desCFA.value = cf.DescripcionLarga;
        this.tresPuntosUniCFA.valorDefault = cf.Unidad;
        costo = this.esMoneda1 ? cf.CostoMoneda1 : cf.CostoMoneda2;
        this.costoCFA.value = ClsUtil.formatoMonedaPipe(costo, this.formatDecImporte.digitsInfo);
        this.expInsCF = cf;
      } else {
        this.costoCFA.value = ClsUtil.formatoMonedaPipe(0, this.formatDecImporte.digitsInfo);
      }
      if (ClsUtil.bigintX(this.mObjCostoHorario.IdCatalogoE) !== 0n) {
        const e: ClsCatalogosExpIns = mapCatalogo.get(ClsUtil.bigintX(this.mObjCostoHorario.IdCatalogoE));
        this.tresPuntosEspera.valorDefault = e.Codigo;
        this.desEspera.value = e.DescripcionLarga;
        this.tresPuntosUniEspera.valorDefault = e.Unidad;
        costo = this.esMoneda1 ? e.CostoMoneda1 : e.CostoMoneda2;
        this.costoEspera.value = ClsUtil.formatoMonedaPipe(costo, this.formatDecImporte.digitsInfo);
        this.expInsE = e;
      } else {
        this.costoEspera.value = ClsUtil.formatoMonedaPipe(0, this.formatDecImporte.digitsInfo);
      }
      if (ClsUtil.bigintX(this.mObjCostoHorario.IdCatalogoR) !== 0n) {
        const r: ClsCatalogosExpIns = mapCatalogo.get(ClsUtil.bigintX(this.mObjCostoHorario.IdCatalogoR));
        this.tresPuntosReserva.valorDefault = r.Codigo;
        this.desReserva.value = r.DescripcionLarga;
        this.tresPuntosUniReserva.valorDefault = r.Unidad;
        costo = this.esMoneda1 ? r.CostoMoneda1 : r.CostoMoneda2;
        this.costoReserva.value = ClsUtil.formatoMonedaPipe(costo, this.formatDecImporte.digitsInfo);
        this.expInsR = r;
      } else {
        this.costoReserva.value = ClsUtil.formatoMonedaPipe(0, this.formatDecImporte.digitsInfo);
      }
      if (ClsUtil.bigintX(this.mObjCostoHorario.IdCatalogoVa) !== 0n) {
        const va: ClsCatalogosExpIns = mapCatalogo.get(ClsUtil.bigintX(this.mObjCostoHorario.IdCatalogoVa));
        this.tresPuntosValorAdq.valorDefault = va.Codigo;
        this.desValorAdq.value = va.DescripcionLarga;
        this.tresPuntosUniValorAdq.valorDefault = va.Unidad;
        costo = this.esMoneda1 ? va.CostoMoneda1 : va.CostoMoneda2;
        this.costoValorAdq.value = ClsUtil.formatoMonedaPipe(costo, this.formatDecImporte.digitsInfo);
        this.setDatosInputs('costoValorAdq', costo);
        this.expInsVA = va;
      } else {
        this.costoValorAdq.value = ClsUtil.formatoMonedaPipe(0, this.formatDecImporte.digitsInfo);
      }
      if (ClsUtil.bigintX(this.mObjCostoHorario.IdCatalogoLla) !== 0n) {
        const lla: ClsCatalogosExpIns = mapCatalogo.get(ClsUtil.bigintX(this.mObjCostoHorario.IdCatalogoLla));
        this.tresPuntosLlantas.valorDefault = lla.Codigo;
        this.desLlantas.value = lla.DescripcionLarga;
        this.tresPuntosUniLlantas.valorDefault = lla.Unidad;
        costo = this.esMoneda1 ? lla.CostoMoneda1 : lla.CostoMoneda2;
        this.costoLlantas.value = ClsUtil.formatoMonedaPipe(costo, this.formatDecImporte.digitsInfo);
        this.setDatosInputs('costoLlantas', costo);
        this.expInsLl = lla;
      } else {
        this.costoLlantas.value = ClsUtil.formatoMonedaPipe(0, this.formatDecImporte.digitsInfo);
      }
      if (ClsUtil.bigintX(this.mObjCostoHorario.IdCatalogoPza) !== 0n) {
        const pza: ClsCatalogosExpIns = mapCatalogo.get(ClsUtil.bigintX(this.mObjCostoHorario.IdCatalogoPza));
        this.tresPuntosPzaEsp.valorDefault = pza.Codigo;
        this.desPzaEsp.value = pza.DescripcionLarga;
        this.tresPuntosUniPzaEsp.valorDefault = pza.Unidad;
        costo = this.esMoneda1 ? pza.CostoMoneda1 : pza.CostoMoneda2;
        this.costoPzaEsp.value = ClsUtil.formatoMonedaPipe(costo, this.formatDecImporte.digitsInfo);
        this.setDatosInputs('costoPzaEsp', costo);
        this.expInsPE = pza;
      } else {
        this.costoPzaEsp.value = ClsUtil.formatoMonedaPipe(0, this.formatDecImporte.digitsInfo);
      }
      if (ClsUtil.bigintX(this.mObjCostoHorario.IdCatalogoComb) !== 0n) {
        const comb: ClsCatalogosExpIns = mapCatalogo.get(ClsUtil.bigintX(this.mObjCostoHorario.IdCatalogoComb));
        this.tresPuntosCombustible.valorDefault = comb.Codigo;
        this.desCombustible.value = comb.DescripcionLarga;
        this.tresPuntosUniCombustible.valorDefault = comb.Unidad;
        costo = this.esMoneda1 ? comb.CostoMoneda1 : comb.CostoMoneda2;
        this.costoCombustible.value = ClsUtil.formatoMonedaPipe(costo, this.formatDecImporte.digitsInfo);
        this.setDatosInputs('costoCombustible', costo);
        this.expInsC = comb;
      } else {
        this.costoCombustible.value = ClsUtil.formatoMonedaPipe(0, this.formatDecImporte.digitsInfo);
      }
      if (ClsUtil.bigintX(this.mObjCostoHorario.IdCatalogoAcei) !== 0n) {
        const acei: ClsCatalogosExpIns = mapCatalogo.get(ClsUtil.bigintX(this.mObjCostoHorario.IdCatalogoAcei));
        this.tresPuntosLubricante.valorDefault = acei.Codigo;
        this.desLubricante.value = acei.DescripcionLarga;
        this.tresPuntosUniLubricante.valorDefault = acei.Unidad;
        costo = this.esMoneda1 ? acei.CostoMoneda1 : acei.CostoMoneda2;
        this.costoLubricante.value = ClsUtil.formatoMonedaPipe(costo, this.formatDecImporte.digitsInfo);
        this.setDatosInputs('costoLubricante', costo);
        this.expInsL = acei;
      } else {
        this.costoLubricante.value = ClsUtil.formatoMonedaPipe(0, this.formatDecImporte.digitsInfo);
      }
      if (ClsUtil.bigintX(this.mObjCostoHorario.IdCatalogoOtrasFuentes) !== 0n) {
        const of: ClsCatalogosExpIns = mapCatalogo.get(ClsUtil.bigintX(this.mObjCostoHorario.IdCatalogoOtrasFuentes));
        this.tresPuntosOtrasFEnergia.valorDefault = of.Codigo;
        this.desOtrasFEnergia.value = of.DescripcionLarga;
        this.tresPuntosUniOtrasFEnergia.valorDefault = of.Unidad;
        costo = this.esMoneda1 ? of.CostoMoneda1 : of.CostoMoneda2;
        this.costoOtrasFEnergia.value = ClsUtil.formatoMonedaPipe(costo, this.formatDecImporte.digitsInfo);
        this.setDatosInputs('costoOtrasFEnergia', costo);
        this.expInsOFE = of;
      } else {
        this.costoOtrasFEnergia.value = ClsUtil.formatoMonedaPipe(0, this.formatDecImporte.digitsInfo);
      }
      this.vidaEconomicaHrsLlantas.value = this.mObjCostoHorario.Hllantas;
      this.setDatosInputs('vidaEconomicaHrsLlantas', this.mObjCostoHorario.Hllantas);
      this.vidaEconomicaHrsPzaEsp.value = this.mObjCostoHorario.HPiezas;
      this.setDatosInputs('vidaEconomicaHrsPzaEsp', this.mObjCostoHorario.HPiezas);
      this.valorMaquinaria.value = ClsUtil.formatoMonedaPipe(0, this.formatDecImporte.digitsInfo);
      // cargo fijo
      this.cfVidaEconomicaHrs.value = this.mObjCostoHorario.Ve;
      this.setDatosInputs('cfVidaEconomicaHrs', this.mObjCostoHorario.Ve);
      this.hrsTrabajadasXAnio.value = this.mObjCostoHorario.Ha;
      this.setDatosInputs('hrsTrabajadasXAño', this.mObjCostoHorario.Ha);
      this.valorRescatePor.value = ClsUtil.formatoMonedaPipeSinSimbolo$ConDecimal(this.mObjCostoHorario.Vr);
      this.setDatosInputs('valorRescatePor', this.mObjCostoHorario.Vr);
      if (this.esMoneda1) {
        this.tasaInteres.value = ClsUtil.formatoMonedaPipeSinSimbolo$ConDecimal(this.mObjCostoHorario.TasaInteresMoneda1, '1.4-4');
        this.setDatosInputs('tasaInteres', this.mObjCostoHorario.TasaInteresMoneda1);
      } else {
        this.tasaInteres.value = ClsUtil.formatoMonedaPipeSinSimbolo$ConDecimal(this.mObjCostoHorario.TasaInteresMoneda2, '1.4-4');
        this.setDatosInputs('tasaInteres', this.mObjCostoHorario.TasaInteresMoneda2);
      }
      this.primaAnualProSeg.value = ClsUtil.formatoMonedaPipeSinSimbolo$ConDecimal(this.mObjCostoHorario.S);
      this.setDatosInputs('primaAnualProSeg', this.mObjCostoHorario.S);
      this.factorMantenimiento.value = ClsUtil.formatoMonedaPipeSinSimbolo$ConDecimal(this.mObjCostoHorario.Q, '1.4-4');
      try {
        this.setDatosInputs('factorMantenimiento', this.mObjCostoHorario.Q);
      } catch (e) {
      }
      // consumos
      this.rTipoLubCom = this.mObjCostoHorario.CalculoDetallado ? '1' : '2';
      this.potenciaDescripcion.value = this.mObjCostoHorario.UnidadPotencia;
      this.potenciaValor.value = ClsUtil.formatoMonedaPipeSinSimbolo$ConDecimal(this.mObjCostoHorario.Potencia);
      this.setDatosInputs('potenciaValor', this.mObjCostoHorario.Potencia);
      this.factorOperacionPor.value = ClsUtil.formatoMonedaPipeSinSimbolo$ConDecimal(this.mObjCostoHorario.Foper);
      this.setDatosInputs('factorOperacionPor', this.mObjCostoHorario.Foper);
      // this.potenciaOpeTotal.value = ClsUtil.formatoMonedaPipeSinSimbolo$ConDecimal(0);
      this.rCombustible = this.mObjCostoHorario.TipoCombustible.toString();
      this.combustibleXHora.value = ClsUtil.formatoMonedaPipeSinSimbolo$ConDecimal(this.mObjCostoHorario.CantidadCombustible, '1.4-4');
      this.setDatosInputs('combustibleXHora', this.mObjCostoHorario.CantidadCombustible);
      this.factorCombustible.value = ClsUtil.formatoMonedaPipeSinSimbolo$ConDecimal(this.mObjCostoHorario.Factcomb, '1.4-4');
      this.setDatosInputs('factorCombustible', this.mObjCostoHorario.Factcomb);
      this.mFactorCombustible = this.mObjCostoHorario.Factcomb;
      this.factorOtrasFuentes.value = ClsUtil.formatoMonedaPipeSinSimbolo$ConDecimal(this.mObjCostoHorario.FactFuentes, '1.4-4');
      this.setDatosInputs('factorOtrasFuentes', this.mObjCostoHorario.FactFuentes);
      this.lubricanteXHora.value = ClsUtil.formatoMonedaPipeSinSimbolo$ConDecimal(this.mObjCostoHorario.CantidadLubricante, '1.4-4');
      this.setDatosInputs('lubricanteXHora', this.mObjCostoHorario.CantidadLubricante);
      this.factorLubricante.value = ClsUtil.formatoMonedaPipeSinSimbolo$ConDecimal(this.mObjCostoHorario.Faceite, '1.4-4');
      this.setDatosInputs('factoLubricante', this.mObjCostoHorario.Faceite);
      this.carterLts.value = ClsUtil.formatoMonedaPipeSinSimbolo$ConDecimal(this.mObjCostoHorario.Ccarter);
      this.setDatosInputs('carterLts', this.mObjCostoHorario.Ccarter);
      this.hrsCambio.value = this.mObjCostoHorario.Horasc;
      this.setDatosInputs('hrsCambio', this.mObjCostoHorario.Horasc);
      if (this.mObjCostoHorario.CalculoDetallado) {
        this.consumoLts.value = ClsUtil.formatoMonedaPipeSinSimbolo$ConDecimal(this.mObjCostoHorario.CantidadCombustible, '1.4-4');
        // this.setDatosInputs('consumoLts', this.mObjCostoHorario.CantidadCombustible);
        this.totalLubricante.value = ClsUtil.formatoMonedaPipeSinSimbolo$ConDecimal(this.mObjCostoHorario.CantidadLubricante, '1.4-4');
      }
      // operacion
      this.mObjCostoHorario.LsCostosHorariosMO = this.mObjCostoHorario.LsCostosHorariosMO ?? [];
      if (this.mObjCostoHorario.LsCostosHorariosMO.length > 0) {
        this.gridOperacion.data = [];
        this.mObjCostoHorario.LsCostosHorariosMO.forEach((value: ClsLsJsonCostosHorariosMO) => {
          const cat: ClsCatalogosExpIns = mapCatalogo.get(ClsUtil.bigintX(value.IdCatalogoMO));
          this.mRowDataOperacion = new ClsDetalleMatrizInsumos();
          this.mRowDataOperacion.Control = ClsUtil.generarIDNumber();
          this.inicializarRegistro(cat, this.gridOperacion, this.mRowDataOperacion, true, value.Volumen, value.Renglon, true);
        });
        await this.commitOperacion();
      }
      // otros consumos
      this.mObjCostoHorario.LsCostosHorariosOC = this.mObjCostoHorario.LsCostosHorariosOC ?? [];
      if (this.mObjCostoHorario.LsCostosHorariosOC.length > 0) {
        this.gridOtrosConsumos.data = [];
        this.mObjCostoHorario.LsCostosHorariosOC.forEach((value: ClsLsJsonCostosHorariosOC) => {
          const cat: ClsCatalogosExpIns = mapCatalogo.get(ClsUtil.bigintX(value.IdCatalogoOC));
          this.mRowDataOtrosConsumos = new ClsDetalleMatrizInsumos();
          this.mRowDataOtrosConsumos.Control = ClsUtil.generarIDNumber();
          this.inicializarRegistro(cat, this.gridOtrosConsumos, this.mRowDataOtrosConsumos, false, value.Volumen, value.Renglon, true);
        });
        await this.commitOtrosCons();
      }
      // detalle
      this.marca.value = this.mObjCostoHorario.Marca;
      this.modelo.value = this.mObjCostoHorario.Modelo;
      this.numeroSerie.value = this.mObjCostoHorario.NumSerie;
      this.capacidad.value = this.mObjCostoHorario.Capacidad;
      this.ubicacion.value = this.mObjCostoHorario.Ubicacion;
      this.vidaUtil.value = this.mObjCostoHorario.VidaUtil;
      this.propietario.value = this.mObjCostoHorario.Propietario;
      this.rDisponibilidad = this.mObjCostoHorario.Disponibilidad === 'p' ? '1' : this.mObjCostoHorario.Disponibilidad === 'c' ? '2' : '3';
      this.mObjCostoHorario.JsonCostosHorariosMO = undefined;
      this.mObjCostoHorario.JsonCostosHorariosOC = undefined;
    } else {
      let mapCatalogo: Map<string, ClsCatalogosExpIns> = ClsUtil.crearMapCatalogoCodigo(allCat);
      // validamos si el codigo de CH inicia con EQ para quitarlo
      const codigo: string = this.filaSeleccionado.Codigo;
      const codAux: string = codigo.startsWith('EQ') ? codigo.substring(2, codigo.length) : codigo;
      let cf: ClsCatalogosExpIns = mapCatalogo.get(`CF${codAux}`);
      let e: ClsCatalogosExpIns = mapCatalogo.get(`${codigo}-E`);
      let r: ClsCatalogosExpIns = mapCatalogo.get(`${codigo}-R`);
      let va: ClsCatalogosExpIns = mapCatalogo.get(`VA${codigo}`);
      // se valida si tienen CF, E, R y VA, si no tiene para crearlo y volver a seteear los valores
      if (ClsUtil.esNulo(cf) && ClsUtil.esNulo(e) && ClsUtil.esNulo(r) && ClsUtil.esNulo(va)) {
        const paramUnidades: ClsParametro[] = await this.mObjGenerico.obtenerNParametros(this.infPpto.organizacion.IdOrganizacion, EnumTipoParametro.Organizacion, [{Parametro: EnumParaOrg.UNIINSESPRES}, {Parametro: EnumParaOrg.UNIVALORADQEQ}]);
        let arrayEQ: ClsCatalogosExpIns[] = this.mObjExpInsumos.crearRegistrosEQ(this.filaSeleccionado, paramUnidades);
        await this.mObjCH.guardarExpIns(arrayEQ, allCat, this.mObjExpInsumos, this.socket);
        // actualizamos el mapa con los nuevos registros
        mapCatalogo = ClsUtil.crearMapCatalogoCodigo(allCat);
        // volvemos a obtener los registros para CF, E, R, VA
        cf = mapCatalogo.get(`CF${codAux}`);
        e = mapCatalogo.get(`${codigo}-E`);
        r = mapCatalogo.get(`${codigo}-R`);
        va = mapCatalogo.get(`VA${codigo}`);
      }
      this.mObjCostoHorario = new ClsCostoHorarios();
      this.mObjCostoHorario.IdPresupuesto = idPpto;
      this.mObjCostoHorario.IdCatalogoCostoHorario = ClsUtil.bigintX(this.filaSeleccionado.IdCatalogo);
      // CF
      this.tresPuntosCFA.valorDefault = ClsUtil.cadenaX(cf.Codigo);
      this.desCFA.value = ClsUtil.cadenaX(cf.DescripcionLarga);
      this.tresPuntosUniCFA.valorDefault = 'HR';
      this.costoCFA.value = ClsUtil.formatoMonedaPipe(0, this.formatDecImporte.digitsInfo);
      this.expInsCF = cf;
      this.mObjCostoHorario.IdCatalogoCF = ClsUtil.bigintX(cf.IdCatalogo);
      // -E
      if (!ClsUtil.esNulo(e)) {
        this.tresPuntosEspera.valorDefault = ClsUtil.cadenaX(e.Codigo);
        this.desEspera.value = ClsUtil.cadenaX(e.DescripcionLarga);
        this.tresPuntosUniEspera.valorDefault = this.infPpto.parametrosOrganizacion.find(param => param.Parametro === EnumParaOrg.UNIINSESPRES).Valor;
        this.costoEspera.value = ClsUtil.formatoMonedaPipe(0, this.formatDecImporte.digitsInfo);
        this.expInsE = e;
        this.mObjCostoHorario.IdCatalogoE = ClsUtil.bigintX(e.IdCatalogo);
      } else {
        this.mObjCostoHorario.IdCatalogoE = ClsUtil.bigintX(0);
        this.costoEspera.value = ClsUtil.formatoMonedaPipe(0, this.formatDecImporte.digitsInfo);
      }

      // -R
      if (!ClsUtil.esNulo(r)) {
        this.tresPuntosReserva.valorDefault = ClsUtil.cadenaX(r.Codigo);
        this.desReserva.value = ClsUtil.cadenaX(r.DescripcionLarga);
        this.tresPuntosUniReserva.valorDefault = this.infPpto.parametrosOrganizacion.find(param => param.Parametro === EnumParaOrg.UNIINSESPRES).Valor;
        this.costoReserva.value = ClsUtil.formatoMonedaPipe(0, this.formatDecImporte.digitsInfo);
        this.expInsR = r;
        this.mObjCostoHorario.IdCatalogoR = ClsUtil.bigintX(r.IdCatalogo);
      } else {
        this.mObjCostoHorario.IdCatalogoR = ClsUtil.bigintX(0);
        this.costoReserva.value = ClsUtil.formatoMonedaPipe(0, this.formatDecImporte.digitsInfo);
      }

      // VA
      if (!ClsUtil.esNulo(va)) {
        this.tresPuntosValorAdq.valorDefault = ClsUtil.cadenaX(va.Codigo);
        this.desValorAdq.value = ClsUtil.cadenaX(va.DescripcionLarga);
        this.tresPuntosUniValorAdq.valorDefault = this.infPpto.parametrosOrganizacion.find(param => param.Parametro === EnumParaOrg.UNIVALORADQEQ).Valor;
        this.costoValorAdq.value = ClsUtil.formatoMonedaPipe(0, this.formatDecImporte.digitsInfo);
        this.expInsVA = va;
        this.mObjCostoHorario.IdCatalogoVa = ClsUtil.bigintX(va.IdCatalogo);
      } else {
        this.mObjCostoHorario.IdCatalogoVa = ClsUtil.bigintX(0);
        this.costoValorAdq.value = ClsUtil.formatoMonedaPipe(0, this.formatDecImporte.digitsInfo);
      }

      // resto inf
      this.mObjCostoHorario.IdCatalogoLla = ClsUtil.bigintX(0);
      this.mObjCostoHorario.IdCatalogoPza = ClsUtil.bigintX(0);
      this.mObjCostoHorario.IdCatalogoComb = ClsUtil.bigintX(0);
      this.mObjCostoHorario.IdCatalogoAcei = ClsUtil.bigintX(0);
      this.mObjCostoHorario.IdCatalogoOtrasFuentes = ClsUtil.bigintX(0);
      this.mObjCostoHorario.ProponerCodigos = false;
      this.costoLlantas.value = ClsUtil.formatoMonedaPipe(0, this.formatDecImporte.digitsInfo);
      this.costoPzaEsp.value = ClsUtil.formatoMonedaPipe(0, this.formatDecImporte.digitsInfo);
      this.costoCombustible.value = ClsUtil.formatoMonedaPipe(0, this.formatDecImporte.digitsInfo);
      this.costoLubricante.value = ClsUtil.formatoMonedaPipe(0, this.formatDecImporte.digitsInfo);
      this.costoOtrasFEnergia.value = ClsUtil.formatoMonedaPipe(0, this.formatDecImporte.digitsInfo);
      // cargo fijo
      this.vidaEconomicaHrsLlantas.value = 0;
      this.mObjCostoHorario.Hllantas = 0;
      this.vidaEconomicaHrsPzaEsp.value = 0;
      this.mObjCostoHorario.HPiezas = 0;
      this.valorMaquinaria.value = ClsUtil.formatoMonedaPipe(0, this.formatDecImporte.digitsInfo);
      this.cfVidaEconomicaHrs.value = 0;
      this.mObjCostoHorario.Ve = 0;
      this.hrsTrabajadasXAnio.value = 0;
      this.mObjCostoHorario.Ha = 0;
      this.valorRescatePor.value = ClsUtil.formatoMonedaPipeSinSimbolo$ConDecimal(0);
      this.mObjCostoHorario.Vr = 0;
      this.mObjCostoHorario.TasaInteresMoneda1 = 0;
      this.mObjCostoHorario.TasaInteresMoneda2 = 0;
      if (this.esMoneda1) {
        this.tasaInteres.value = ClsUtil.formatoMonedaPipeSinSimbolo$ConDecimal(this.mObjCostoHorario.TasaInteresMoneda1, '1.4-4');
      } else {
        this.tasaInteres.value = ClsUtil.formatoMonedaPipeSinSimbolo$ConDecimal(this.mObjCostoHorario.TasaInteresMoneda2, '1.4-4');
      }
      this.primaAnualProSeg.value = ClsUtil.formatoMonedaPipeSinSimbolo$ConDecimal(0);
      this.mObjCostoHorario.S = 0;
      this.factorMantenimiento.value = ClsUtil.formatoMonedaPipeSinSimbolo$ConDecimal(0, '1.4-4');
      this.mObjCostoHorario.Q = 0;
      this.depreciacion.value = ClsUtil.formatoMonedaPipe(0, this.formatDecImporte.digitsInfo);
      this.inversion.value = ClsUtil.formatoMonedaPipe(0, this.formatDecImporte.digitsInfo);
      this.seguro.value = ClsUtil.formatoMonedaPipe(0, this.formatDecImporte.digitsInfo);
      this.mantenimiento.value = ClsUtil.formatoMonedaPipe(0, this.formatDecImporte.digitsInfo);
      this.totalCF.value = ClsUtil.formatoMonedaPipe(0, this.formatDecImporte.digitsInfo);
      //  consumos
      this.rTipoLubCom = '1';
      this.mObjCostoHorario.CalculoDetallado = true;
      this.potenciaDescripcion.value = this.infPpto.parametrosOrganizacion.find(param => param.Parametro === EnumParaOrg.UNIPOTENCIACH).Valor;
      this.mObjCostoHorario.UnidadPotencia = this.potenciaDescripcion.value;
      this.potenciaValor.value = ClsUtil.formatoMonedaPipeSinSimbolo$ConDecimal(0);
      this.mObjCostoHorario.Potencia = 0;
      this.factorOperacionPor.value = ClsUtil.formatoMonedaPipeSinSimbolo$ConDecimal(0);
      this.mObjCostoHorario.Foper = 0;
      this.potenciaOpeTotal.value = ClsUtil.formatoMonedaPipeSinSimbolo$ConDecimal(0);
      this.rCombustible = '1';
      this.mObjCostoHorario.TipoCombustible = 1;
      this.combustibleXHora.value = ClsUtil.formatoMonedaPipeSinSimbolo$ConDecimal(0, '1.4-4');
      this.mObjCostoHorario.CantidadCombustible = 0;
      this.factorCombustible.value = ClsUtil.formatoMonedaPipeSinSimbolo$ConDecimal(this.infPpto.parametrosPpto.find(param => param.Parametro === EnumParaPpto.CHFACTORCOMBUTIBLEGASOLINA).Valor, '1.4-4');
      this.mObjCostoHorario.Factcomb = Number(this.infPpto.parametrosPpto.find(param => param.Parametro === EnumParaPpto.CHFACTORCOMBUTIBLEGASOLINA).Valor);
      this.consumoLts.value = ClsUtil.formatoMonedaPipeSinSimbolo$ConDecimal(0, '1.4-4');
      this.factorOtrasFuentes.value = ClsUtil.formatoMonedaPipeSinSimbolo$ConDecimal(0, '1.4-4');
      this.mObjCostoHorario.FactFuentes = 0;
      this.lubricanteXHora.value = ClsUtil.formatoMonedaPipeSinSimbolo$ConDecimal(0, '1.4-4');
      this.mObjCostoHorario.CantidadLubricante = 0;
      this.factorLubricante.value = ClsUtil.formatoMonedaPipeSinSimbolo$ConDecimal(this.infPpto.parametrosPpto.find(param => param.Parametro === EnumParaPpto.CHFACTORLUBRICANTEP0).Valor, '1.4-4');
      this.mObjCostoHorario.Faceite = Number(this.infPpto.parametrosPpto.find(param => param.Parametro === EnumParaPpto.CHFACTORLUBRICANTEP0).Valor);
      this.carterLts.value = ClsUtil.formatoMonedaPipeSinSimbolo$ConDecimal(0);
      this.mObjCostoHorario.Ccarter = 0;
      this.hrsCambio.value = 0;
      this.mObjCostoHorario.Horasc = 0;
      this.totalLubricante.value = ClsUtil.formatoMonedaPipeSinSimbolo$ConDecimal(0, '1.4-4');
      // operacion
      this.mObjCostoHorario.LsCostosHorariosMO = [];
      // otros consumos
      this.mObjCostoHorario.LsCostosHorariosOC = [];
      // valor comercial
      this.mObjCostoHorario.ValorComercial = 0;
      // detalle
      this.rDisponibilidad = '1';
      this.mObjCostoHorario.Marca = '';
      this.mObjCostoHorario.Modelo = '';
      this.mObjCostoHorario.NumSerie = '';
      this.mObjCostoHorario.Capacidad = '';
      this.mObjCostoHorario.Ubicacion = '';
      this.mObjCostoHorario.VidaUtil = '';
      this.mObjCostoHorario.Propietario = '';
      this.mObjCostoHorario.Disponibilidad = 'p';
      // pie totales
      this.ttotalCF.value = ClsUtil.formatoMonedaPipe(0, this.formatDecImporte.digitsInfo);
      this.ttotalOperacion.value = ClsUtil.formatoMonedaPipe(0, this.formatDecImporte.digitsInfo);
      this.ttotalConsumos.value = ClsUtil.formatoMonedaPipe(0, this.formatDecImporte.digitsInfo);
      this.ttotalCostoActivo.value = ClsUtil.formatoMonedaPipe(0, this.formatDecImporte.digitsInfo);
      this.ttotalCostoEspera.value = ClsUtil.formatoMonedaPipe(0, this.formatDecImporte.digitsInfo);
      this.ttotalCostoReserva.value = ClsUtil.formatoMonedaPipe(0, this.formatDecImporte.digitsInfo);
    }
    this.regresaDatosExcel();
  }

  public filaSeleccionada(expIns: ClsCatalogosExpIns, tipo: EnumTipoTresPuntos) {
    try {
      if (this.mObjCH.validarSeleccionCodigo(expIns, this.filaSeleccionado.Codigo)) {
        this.setValoresTresPuntos(expIns, tipo);
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message);
    }
  }

  public setValoresTresPuntos(expIns: ClsCatalogosExpIns, tipo: EnumTipoTresPuntos) {
    let costo: number;
    try {
      if (ClsUtil.esNulo(expIns)) {
        costo = 0;
      } else {
        costo = (this.esMoneda1) ? expIns.CostoMoneda1 : expIns.CostoMoneda2;
      }
      switch (tipo) {
        case EnumTipoTresPuntos.CF:
          // If CInt(mObjCostoHorario.IdExpInsEquipo) > 0 Then
          // If CInt(Dr('IdExpInsCF')) > 0 AndAlso CInt(Dr('CHIdExpInsCF')) <> CInt(.IdExpInsEquipo) Then Throw New Exception('Este insumo ya participa como cargo fijo en otro equipo')
          // If CInt(Dr('IdExpInsVA')) > 0 Then Throw New Exception('Este insumo ya participa como valor de adquisición')
          // If CInt(Dr('IdExpinsE')) > 0 Then Throw New Exception('Este insumo ya participa como equipo en espera')
          // If CInt(Dr('IdExpinsR')) > 0 Then Throw New Exception('Este insumo ya participa como equipo en reserva')
          // End If
          this.expInsCF = expIns;
          this.tresPuntosCFA.idDefault = ClsUtil.esNulo(expIns) ? BigInt(0) : expIns.IdCatalogo;
          this.tresPuntosCFA.valorDefault = ClsUtil.esNulo(expIns) ? '' : expIns.Codigo;
          this.desCFA.value = ClsUtil.esNulo(expIns) ? '' : expIns.DescripcionLarga;
          this.tresPuntosUniCFA.valorDefault = ClsUtil.esNulo(expIns) ? '' : expIns.Unidad;
          this.costoCFA.value = ClsUtil.formatoMonedaPipe(costo, this.formatDecImporte.digitsInfo);
          break;
        case EnumTipoTresPuntos.Espera:
          // If CInt(mObjCostoHorario.IdExpInsEquipo) > 0 Then
          // If CInt(Dr('IdExpinsE')) > 0 AndAlso CInt(Dr('CHIdExpInsE')) <> CInt(.IdExpInsEquipo) Then Throw New Exception('Este insumo ya participa como equipo en espera otro equipo')
          // If CInt(Dr('IdExpInsCF')) > 0 Then Throw New Exception('Este insumo ya participa como cargo fijo')
          // If CInt(Dr('IdExpInsVA')) > 0 Then Throw New Exception('Este insumo ya participa como valor de adquisición')
          // If CInt(Dr('IdExpinsR')) > 0 Then Throw New Exception('Este insumo ya participa como equipo en reserva')
          // End If
          this.expInsE = expIns;
          this.tresPuntosEspera.idDefault = ClsUtil.esNulo(expIns) ? BigInt(0) : expIns.IdCatalogo;
          this.tresPuntosEspera.valorDefault = ClsUtil.esNulo(expIns) ? '' : expIns.Codigo;
          this.desEspera.value = ClsUtil.esNulo(expIns) ? '' : expIns.DescripcionLarga;
          this.tresPuntosUniEspera.valorDefault = ClsUtil.esNulo(expIns) ? '' : expIns.Unidad;
          this.costoEspera.value = ClsUtil.formatoMonedaPipe(costo, this.formatDecImporte.digitsInfo);
          this.regresaDatosExcel();
          break;
        case EnumTipoTresPuntos.Reserva:
          // If CInt(mObjCostoHorario.IdExpInsEquipo) > 0 Then
          // If CInt(Dr('IdExpinsR')) > 0 AndAlso CInt(Dr('CHIdExpInsR')) <> CInt(.IdExpInsEquipo) Then Throw New Exception('Este insumo ya participa como equipo en reserva otro equipo')
          // If CInt(Dr('IdExpInsCF')) > 0 Then Throw New Exception('Este insumo ya participa como cargo fijo')
          // If CInt(Dr('IdExpInsVA')) > 0 Then Throw New Exception('Este insumo ya participa como valor de adquisición')
          // If CInt(Dr('IdExpinsE')) > 0 Then Throw New Exception('Este insumo ya participa como equipo en espera')
          // End If
          this.expInsR = expIns;
          this.tresPuntosReserva.idDefault = ClsUtil.esNulo(expIns) ? BigInt(0) : expIns.IdCatalogo;
          this.tresPuntosReserva.valorDefault = ClsUtil.esNulo(expIns) ? '' : expIns.Codigo;
          this.desReserva.value = ClsUtil.esNulo(expIns) ? '' : expIns.DescripcionLarga;
          this.tresPuntosUniReserva.valorDefault = ClsUtil.esNulo(expIns) ? '' : expIns.Unidad;
          this.costoReserva.value = ClsUtil.formatoMonedaPipe(costo, this.formatDecImporte.digitsInfo);
          this.regresaDatosExcel();
          break;
        case EnumTipoTresPuntos.VA:
          // If CInt(mObjCostoHorario.IdExpInsEquipo) > 0 Then
          // If CInt(Dr('IdExpInsVA')) > 0 AndAlso CInt(Dr('CHIdExpInsVA')) <> CInt(.IdExpInsEquipo) Then Throw New Exception('Este insumo ya participa como valor de adquisición en otro equipo')
          // If CInt(Dr('IdExpInsCF')) > 0 Then Throw New Exception('Este insumo ya participa como cargo fijo')
          // If CInt(Dr('IdExpinsE')) > 0 Then Throw New Exception('Este insumo ya participa como equipo en espera')
          // If CInt(Dr('IdExpinsR')) > 0 Then Throw New Exception('Este insumo ya participa como equipo en reserva')
          // End If
          this.expInsVA = expIns;
          this.tresPuntosValorAdq.idDefault = ClsUtil.esNulo(expIns) ? BigInt(0) : expIns.IdCatalogo;
          this.tresPuntosValorAdq.valorDefault = ClsUtil.esNulo(expIns) ? '' : expIns.Codigo;
          this.desValorAdq.value = ClsUtil.esNulo(expIns) ? '' : expIns.DescripcionLarga;
          this.tresPuntosUniValorAdq.valorDefault = ClsUtil.esNulo(expIns) ? '' : expIns.Unidad;
          this.costoValorAdq.value = ClsUtil.formatoMonedaPipe(costo, this.formatDecImporte.digitsInfo);
          break;
        case EnumTipoTresPuntos.Llantas:
          this.expInsLl = expIns;
          this.tresPuntosLlantas.idDefault = ClsUtil.esNulo(expIns) ? BigInt(0) : expIns.IdCatalogo;
          this.tresPuntosLlantas.valorDefault = ClsUtil.esNulo(expIns) ? '' : expIns.Codigo;
          this.desLlantas.value = ClsUtil.esNulo(expIns) ? '' : expIns.DescripcionLarga;
          this.tresPuntosUniLlantas.valorDefault = ClsUtil.esNulo(expIns) ? '' : expIns.Unidad;
          this.costoLlantas.value = ClsUtil.formatoMonedaPipe(costo, this.formatDecImporte.digitsInfo);
          this.enviarCostoAExcel('PrecioLlantas', costo);
          this.regresaDatosExcel();
          break;
        case EnumTipoTresPuntos.PzaEsp:
          this.expInsPE = expIns;
          this.tresPuntosPzaEsp.idDefault = ClsUtil.esNulo(expIns) ? BigInt(0) : expIns.IdCatalogo;
          this.tresPuntosPzaEsp.valorDefault = ClsUtil.esNulo(expIns) ? '' : expIns.Codigo;
          this.desPzaEsp.value = ClsUtil.esNulo(expIns) ? '' : expIns.DescripcionLarga;
          this.tresPuntosUniPzaEsp.valorDefault = ClsUtil.esNulo(expIns) ? '' : expIns.Unidad;
          this.costoPzaEsp.value = ClsUtil.formatoMonedaPipe(costo, this.formatDecImporte.digitsInfo);
          this.enviarCostoAExcel('CostoPzsEsp', costo);
          this.regresaDatosExcel();
          break;
        case EnumTipoTresPuntos.Combustible:
          this.expInsC = expIns;
          this.tresPuntosCombustible.idDefault = ClsUtil.esNulo(expIns) ? BigInt(0) : expIns.IdCatalogo;
          this.tresPuntosCombustible.valorDefault = ClsUtil.esNulo(expIns) ? '' : expIns.Codigo;
          this.desCombustible.value = ClsUtil.esNulo(expIns) ? '' : expIns.DescripcionLarga;
          this.tresPuntosUniCombustible.valorDefault = ClsUtil.esNulo(expIns) ? '' : expIns.Unidad;
          this.costoCombustible.value = ClsUtil.formatoMonedaPipe(costo, this.formatDecImporte.digitsInfo);
          this.enviarCostoAExcel('CostoCombustible', costo);
          this.regresaDatosExcel();
          break;
        case EnumTipoTresPuntos.Lubricante:
          this.expInsL = expIns;
          this.tresPuntosLubricante.idDefault = ClsUtil.esNulo(expIns) ? BigInt(0) : expIns.IdCatalogo;
          this.tresPuntosLubricante.valorDefault = ClsUtil.esNulo(expIns) ? '' : expIns.Codigo;
          this.desLubricante.value = ClsUtil.esNulo(expIns) ? '' : expIns.DescripcionLarga;
          this.tresPuntosUniLubricante.valorDefault = ClsUtil.esNulo(expIns) ? '' : expIns.Unidad;
          this.costoLubricante.value = ClsUtil.formatoMonedaPipe(costo, this.formatDecImporte.digitsInfo);
          this.enviarCostoAExcel('CostoLubricante', costo);
          this.regresaDatosExcel();
          break;
        case EnumTipoTresPuntos.OtrasFEnergia:
          this.expInsOFE = expIns;
          this.tresPuntosOtrasFEnergia.idDefault = ClsUtil.esNulo(expIns) ? BigInt(0) : expIns.IdCatalogo;
          this.tresPuntosOtrasFEnergia.valorDefault = ClsUtil.esNulo(expIns) ? '' : expIns.Codigo;
          this.desOtrasFEnergia.value = ClsUtil.esNulo(expIns) ? '' : expIns.DescripcionLarga;
          this.tresPuntosUniOtrasFEnergia.valorDefault = ClsUtil.esNulo(expIns) ? '' : expIns.Unidad;
          this.costoOtrasFEnergia.value = ClsUtil.formatoMonedaPipe(costo, this.formatDecImporte.digitsInfo);
          this.enviarCostoAExcel('CostoOtrasFuentes', costo);
          this.regresaDatosExcel();
          break;
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message);
    }
  }

  public agregarCodigo(resp: any, tipo: EnumTipoTresPuntos) {
    let componente: IgxInputDirective;
    try {
      // si resp.registro es undefined indica que se debe limpiar los datos
      // en caso contrario si existe o es nuevo, pero la bandera resp.esNuevo nos dira que es
      let expIns: ClsCatalogosExpIns = resp.registro;
      let esNuevo: boolean = resp.esNuevo;
      componente = resp.comp;
      if (!ClsUtil.esNulo(expIns) && this.mObjCH.validarSeleccionCodigo(expIns, this.filaSeleccionado.Codigo)) {
        if (esNuevo) {
          // buscar en tab operacion y otros consumos si no existe el codigo
          let codigoExiste: ClsDetalleMatrizInsumos;
          let existe = false;
          if (this.gridOperacion.data.length > 0) {
            codigoExiste = this.gridOperacion.data.find(value => value.Codigo === expIns.Codigo);
            if (!ClsUtil.esNulo(codigoExiste)) {
              existe = true;
            }
          }
          if (this.gridOtrosConsumos.data.length > 0 && !existe) {
            codigoExiste = this.gridOtrosConsumos.data.find(value => value.Codigo === expIns.Codigo);
          }
          if (!ClsUtil.esNulo(codigoExiste)) {
            expIns = this.mObjExpInsumos.inicializarAsignarRegistro(undefined);
            expIns.Codigo = componente.value;
            expIns.Descripcion = codigoExiste.Descripcion;
            expIns.DescripcionLarga = codigoExiste.DescripcionLarga;
            expIns.Unidad = codigoExiste.Unidad;
            expIns.CostoMoneda1 = codigoExiste.CostoMoneda1;
            expIns.CostoMoneda2 = codigoExiste.CostoMoneda2;
            expIns.Tipo = codigoExiste.TipoInsumo;
            esNuevo = false;
          }
          if (esNuevo) {
            switch (tipo) {
              case EnumTipoTresPuntos.CF:
                expIns.Unidad = 'HOR';
                expIns.Tipo = 3;
                expIns.CostoMoneda1 = ClsUtil.esNulo(this.expInsCF) ? 0 : this.expInsCF.CostoMoneda1;
                expIns.CostoMoneda2 = ClsUtil.esNulo(this.expInsCF) ? 0 : this.expInsCF.CostoMoneda2;
                break;
              case EnumTipoTresPuntos.Espera:
                expIns.Unidad = this.infPpto.parametrosOrganizacion.find(para => para.Parametro === EnumParaOrg.UNIINSESPRES).Valor;
                expIns.Tipo = 3;
                expIns.CostoMoneda1 = ClsUtil.esNulo(this.expInsE) ? 0 : this.expInsE.CostoMoneda1;
                expIns.CostoMoneda2 = ClsUtil.esNulo(this.expInsE) ? 0 : this.expInsE.CostoMoneda2;
                break;
              case EnumTipoTresPuntos.Reserva:
                expIns.Unidad = this.infPpto.parametrosOrganizacion.find(para => para.Parametro === EnumParaOrg.UNIINSESPRES).Valor;
                expIns.Tipo = 3;
                expIns.CostoMoneda1 = ClsUtil.esNulo(this.expInsR) ? 0 : this.expInsR.CostoMoneda1;
                expIns.CostoMoneda2 = ClsUtil.esNulo(this.expInsR) ? 0 : this.expInsR.CostoMoneda2;
                break;
              case EnumTipoTresPuntos.VA:
                expIns.Unidad = this.infPpto.parametrosOrganizacion.find(para => para.Parametro === EnumParaOrg.UNIVALORADQEQ).Valor;
                break;
              case EnumTipoTresPuntos.Llantas:
                expIns.Unidad = this.infPpto.parametrosOrganizacion.find(para => para.Parametro === EnumParaOrg.UNIINSLLANTAS).Valor;
                break;
              case EnumTipoTresPuntos.PzaEsp:
                expIns.Unidad = this.infPpto.parametrosOrganizacion.find(para => para.Parametro === EnumParaOrg.UNIINSPZAESP).Valor;
                break;
              case EnumTipoTresPuntos.Combustible:
                expIns.Unidad = this.infPpto.parametrosOrganizacion.find(para => para.Parametro === EnumParaOrg.UNIINSCOMBUSTIBLEEQ).Valor;
                break;
              case EnumTipoTresPuntos.Lubricante:
                expIns.Unidad = this.infPpto.parametrosOrganizacion.find(para => para.Parametro === EnumParaOrg.UNIINSLUBEQ).Valor;
                break;
              case EnumTipoTresPuntos.OtrasFEnergia:
                break;
            }
          }
        }
      }
      this.setValoresTresPuntos(expIns, tipo);
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message);
      componente.value = '';
      componente.focus();
    }
  }

  public regenerarFormato(elemento: any, conSimbolo$ = true, conDecimales = false, digitsInfo = '1.2-2') {
    let valor: any;
    try {
      valor = ClsUtil.numberX(elemento.target.value, true);
      if (elemento.target.id === 'factorMantenimiento') {
        try {
          this.setDatosInputs(elemento.target.id, valor);
        } catch (e) {
          if (e.message !== 'MENSAJES.ALERT.CH_VALOR_MAXIMO1.5') {
            throw new Error(e.message);
          }
          this.tipoMsg.mostrarMsg(e.message);
        }
      } else {
        this.setDatosInputs(elemento.target.id, valor);
      }
      this.regresaDatosExcel();
      if (conDecimales) {
        if (conSimbolo$) {
          elemento.target.value = ClsUtil.formatoMonedaPipe(valor, digitsInfo);
        } else {
          elemento.target.value = ClsUtil.formatoMonedaPipeSinSimbolo$ConDecimal(valor, digitsInfo);
        }
      }
    } catch (e) {
      elemento.target.focus();
      elemento.target.value = 0;
      this.tipoMsg.mostrarMsg(e.message);
    }
  }

  public setDatosInputs(idElemento: string, valor: number) {
    try {
      switch (idElemento) {
        // datos
        case 'costoValorAdq':
          this.mHojaDatos.getCell('PrecioAdquisicion').value = valor;
          break;
        case 'costoLlantas':
          this.mHojaDatos.getCell('PrecioLlantas').value = valor;
          break;
        case 'costoPzaEsp':
          this.mHojaDatos.getCell('CostoPzsEsp').value = valor;
          break;
        case 'costoCombustible':
          this.mHojaDatos.getCell('CostoCombustible').value = valor;
          break;
        case 'costoLubricante':
          this.mHojaDatos.getCell('CostoLubricante').value = valor;
          break;
        case 'costoOtrasFEnergia':
          this.mHojaDatos.getCell('CostoOtrasFuentes').value = valor;
          break;
        case 'vidaEconomicaHrsLlantas':
          this.mHojaDatos.getCell('VidaEcoLlantasHrs').value = valor;
          break;
        case 'vidaEconomicaHrsPzaEsp':
          this.mHojaDatos.getCell('VidaEcoPiezasHrs').value = valor;
          break;
        //  cargo fijo
        case 'cfVidaEconomicaHrs':
          this.mHojaDatos.getCell('VidaEcoEQHrs').value = valor;
          break;
        case 'hrsTrabajadasXAño':
          this.mHojaDatos.getCell('HorasXAño').value = valor;
          break;
        case 'valorRescatePor':
          if (valor > 100) {
            throw new Error('MENSAJES.ALERT.CH_VALOR_RESCATE_MAYOR100');
          }
          this.mHojaDatos.getCell('ValorRescate').value = valor / 100;
          break;
        case 'tasaInteres':
          if (valor > 100) {
            throw new Error('MENSAJES.ALERT.CH_VALOR_INTERES_MAYOR100');
          }
          this.mHojaDatos.getCell('TasaInteres').value = valor / 100;
          break;
        case 'primaAnualProSeg':
          if (valor > 100) {
            throw new Error('MENSAJES.ALERT.CH_PORCENTAJE_SEGURO_MAYOR100');
          }
          this.mHojaDatos.getCell('PrimaSeguros').value = ClsUtil.evaluadorExpresiones(valor, 4) / 100;
          break;
        case 'factorMantenimiento':
          if (valor > 1.5 && valor <= 3) {
            throw new Error('MENSAJES.ALERT.CH_VALOR_MAXIMO1.5');
          }
          if (valor > 3) {
            throw new Error('MENSAJES.ALERT.CH_FACTOR_MANT_MAYOR3');
          }
          this.mHojaDatos.getCell('FactorMantenimiento').value = valor;
          break;
        //  consumos
        case 'potenciaValor':
          if (valor > 100) {
            this.factorLubricante.value = this.infPpto.parametrosPpto.find(param => param.Parametro === EnumParaPpto.CHFACTORLUBRICANTEPMAYOR0).Valor;
          }
          this.mHojaDatos.getCell('PotenciaNominal').value = valor;
          this.vaciaCostoDetallado();
          break;
        case 'factorOperacionPor':
          if (valor > 100) {
            throw new Error('MENSAJES.ALERT.CH_FACTOR_OPER_MAYOR100');
          }
          this.mHojaDatos.getCell('FactorOperacion').value = valor / 100;
          break;
        case 'combustibleXHora':
          this.mHojaDatos.getCell('CantidadCombustible_sinDetalle').value = valor;
          break;
        case 'factorCombustible':
          this.mHojaDatos.getCell('FactorCombustible').value = valor;
          break;
        case 'consumoLts':
          if (this.rTipoLubCom === '1') {
            this.mHojaDatos.getCell('ConsumoDeseado').value = valor;
            this.factorCombustible.value = this.mHojaDatos.getCell('NuevoCoeficienteCombustible').value;
            this.mHojaDatos.getCell('FactorCombustible').value = this.mHojaDatos.getCell('NuevoCoeficienteCombustible').value;
          } else {
            this.mHojaDatos.getCell('CantidadCombustible_sinDetalle').value = valor;
          }
          break;
        case 'factorOtrasFuentes':
          this.mHojaDatos.getCell('FactorOtrasFuentes').value = valor;
          break;
        case 'lubricanteXHora':
          this.mHojaDatos.getCell('CantidadLubricante_sinDetalle').value = valor;
          break;
        case 'factoLubricante':
          this.mHojaDatos.getCell('FactorLubricante').value = valor;
          break;
        case 'carterLts':
          this.mHojaDatos.getCell('CapacidadCarter').value = valor;
          break;
        case 'hrsCambio':
          this.mHojaDatos.getCell('TiempoCambioLub').value = valor;
          break;
        // case 'totalLubricante':
        //   this.mHojaDatos.getCell('VidaEcoPiezasHrs').value = valor;
        //   break;
        //  pie de totales
        case 'ttotalCF':
          this.mHojaDatos.getCell('CargoFijoDeseado').value = valor;
          this.costoValorAdq.value = this.mHojaDatos.getCell('NuevoValorAdquisicion').value;
          this.mHojaDatos.getCell('PrecioAdquisicion').value = this.mHojaDatos.getCell('NuevoValorAdquisicion').value;
          break;
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public cambioTipoLubCom(evt: IChangeCheckboxEventArgs) {
    this.rTipoLubCom = evt.value;
    this.vaciaCostoDetallado();
    this.regresaDatosExcel();
  }

  public cambioDisponibilidad(evt: IChangeCheckboxEventArgs) {
    this.rDisponibilidad = evt.value;
  }

  public cambioTipoCom(evt: IChangeCheckboxEventArgs) {
    let factorDefault: number;
    switch (evt.value) {
      case '1':
        factorDefault = Number(this.infPpto.parametrosPpto.find(param => param.Parametro === EnumParaPpto.CHFACTORCOMBUTIBLEGASOLINA).Valor);
        if (this.rCombustible === '1' && this.mFactorCombustible >= 0 && this.mFactorCombustible !== factorDefault) {
          this.factorCombustible.value = ClsUtil.formatoMonedaPipeSinSimbolo$ConDecimal(this.mFactorCombustible, '1.4-4');
        } else {
          this.factorCombustible.value = ClsUtil.formatoMonedaPipeSinSimbolo$ConDecimal(factorDefault, '1.4-4');
        }
        break;
      case '2':
        factorDefault = Number(this.infPpto.parametrosPpto.find(param => param.Parametro === EnumParaPpto.CHFACTORCOMBUTIBLEDIESEL).Valor);
        if (this.rCombustible === '2' && this.mFactorCombustible >= 0 && this.mFactorCombustible !== factorDefault) {
          this.factorCombustible.value = ClsUtil.formatoMonedaPipeSinSimbolo$ConDecimal(this.mFactorCombustible, '1.4-4');
        } else {
          this.factorCombustible.value = ClsUtil.formatoMonedaPipeSinSimbolo$ConDecimal(factorDefault, '1.4-4');
        }
        break;
      case '3':
        factorDefault = Number(this.infPpto.parametrosPpto.find(param => param.Parametro === EnumParaPpto.CHFACTORCOMBUTIBLEOTROS).Valor);
        if (this.rCombustible === '3' && this.mFactorCombustible >= 0 && this.mFactorCombustible !== factorDefault) {
          this.factorCombustible.value = ClsUtil.formatoMonedaPipeSinSimbolo$ConDecimal(this.mFactorCombustible, '1.4-4');
        } else {
          this.factorCombustible.value = ClsUtil.formatoMonedaPipeSinSimbolo$ConDecimal(factorDefault, '1.4-4');
        }
        break;
    }
    this.vaciaCostoDetallado();
    this.regresaDatosExcel();
  }

  public get hasTransactionsOperacion(): boolean {
    return this.gridOperacion.transactions.getAggregatedChanges(false).length > 0;
  }

  public rowEditEnterOperacion(evt: IGridEditEventArgs) {
    if (evt.isAddRow && this.gridOperacion.groupingFlatResult.length === 4) {
      this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsSubject('MENSAJES.ALERT.CH_MAXIMO_REGISTROS').replace('{0}', '4'));
      evt.cancel = true;
      this.gridOperacion.transactions.clear(evt.rowKey);
      return;
    }
    this.showActionStripOperacion = false;
    this.mRowDataOperacion = evt.rowData;
  }

  public rowEditExitOperacion() {
    this.showActionStripOperacion = true;
    if (ClsUtil.esNulo(this.mRowDataOperacion.Codigo)) {
      this.gridOperacion.transactions.clear(this.mRowDataOperacion.Control);
      const index: any = this.gridOperacion.groupingFlatResult.findIndex(value => value.Control === this.mRowDataOperacion.Control);
      this.gridOperacion.groupingFlatResult.splice(index, 1);
    }
    this.vaciaOperacionAExcel();
    this.regresaDatosExcel();
  }

  public async commitOperacion(saveBD = false) {
    if (ClsUtil.esNulo(this.expInsCF) && saveBD) {
      await new Promise(resolve => this.tipoMsg.mostrarMsgPromise((resp) => resolve(resp), 'MENSAJES.ALERT.VALIDAR_CF_CH', undefined, 'error')).then(value => value);
      this.tabGeneral.selectedIndex = 0;
      this.tresPuntosCFA.inputCatalogos.focus();
      return;
    }
    if (saveBD) {
      this.tipoMsg.mostrarQuestion(async (resp: boolean) => {
        if (resp) {
          try {
            this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.GUARDANDO_DATOS');
            this.gridOperacion.transactions.commit(this.gridOperacion.data);
            this.vaciaOperacionAExcel();
            this.regresaDatosExcel();
            const catExpIns = ClsUtil.getPptoCompletoActivoMaestroJSON(this.infPpto).CatExpIns;
            const allExpInsCopy: ClsCatalogosExpIns[] = catExpIns.map((x) => ({ ...x }));
            // Snapshot solo para comparar "antes" vs "después" (no va al Map)
            const allExpInsAntes: ClsCatalogosExpIns[] = allExpInsCopy.map((x) => ({ ...x }));
            const mapCatalogo: Map<string, ClsCatalogosExpIns> = ClsUtil.crearMapCatalogoCodigo(allExpInsCopy);
            this.mObjCostoHorario.LsCostosHorariosMO = await this.guardarGridsBD(this.gridOperacion, true, mapCatalogo, allExpInsAntes);
            await this.mObjCH.registraActualizaCostoHorario([this.mObjCostoHorario]);
          } catch (e) {
            this.restaurarGridsSiFallaAlGuardar(this.gridOperacion);
            this.tipoMsg.mostrarMsg(e.message);
          } finally {
            this.tipoMsg.cerrarWaitDialog();
          }
        }
      }, this.mObjGenerico.getTranslationsSubject('MENSAJES.QUESTION.GUARDAR_CH'));
    } else {
      this.gridOperacion.transactions.commit(this.gridOperacion.data);
      this.vaciaOperacionAExcel();
      this.regresaDatosExcel();
    }
  }

  private restaurarGridsSiFallaAlGuardar(grid: IgxGridComponent) {
    // si manda error al guardar la inf, limpiamos la data y volvemos agregar la inf
    const dataAux: ClsDetalleMatrizInsumos[] = grid.data;
    grid.data = [];
    dataAux.forEach(value => {
      grid.addRow(value);
    });
  }

  private async guardarGridsBD(grid: IgxGridComponent, gridOperacion: boolean, mapCatalogo: Map<string, ClsCatalogosExpIns>, allExpInsAntes: ClsCatalogosExpIns[]): Promise<any[]> {
    const lsCH: any[] = [];
    try {
      // creamos Obj de exp
      let arrayExp: ClsCatalogosExpIns[];
      arrayExp = this.mObjCH.crearObjMatrizACatalogo(grid, this.mObjExpInsumos, mapCatalogo);
      if (arrayExp.length > 0) {
        arrayExp = await this.mObjCH.guardarExpIns(arrayExp, allExpInsAntes, this.mObjExpInsumos, this.socket);
        //  crear obj para guarda el ch
        arrayExp.forEach(value => {
          const reg: ClsDetalleMatrizInsumos = grid.data.find(value1 => value1.Codigo === value.Codigo);
          if (gridOperacion) {
            lsCH.push({IdCatalogoMO: value.IdCatalogo, Renglon: reg.Renglon, Volumen: reg.Volumen});
          } else {
            lsCH.push({IdCatalogoOC: value.IdCatalogo, Renglon: reg.Renglon, Volumen: reg.Volumen});
          }
        });
        return lsCH;
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public undoOperacion() {
    this.gridOperacion.endEdit(true);
    this.gridOperacion.transactions.undo();
    this.vaciaOperacionAExcel();
    this.regresaDatosExcel();
  }

  public redoOperacion() {
    this.gridOperacion.endEdit(true);
    this.gridOperacion.transactions.redo();
    this.vaciaOperacionAExcel();
    this.regresaDatosExcel();
  }

  public discardOperacion() {
    this.tipoMsg.mostrarQuestion((resp: boolean) => {
      if (resp) {
        this.gridOperacion.transactions.clear();
        this.vaciaOperacionAExcel();
        this.regresaDatosExcel();
      }
    }, 'MENSAJES.QUESTION.CANCELAR_CAMBIOS');
  }

  public borrarOperacion(registro: any) {
    registro.delete();
    this.vaciaOperacionAExcel();
    this.regresaDatosExcel();
  }

  public inicializarComponenteCodigoOperacion(e: TresPuntosComponent) {
    this.tresPuntosCodigoOperacion = e;
    const matriz = this.mObjMatrices.inicializarInsumo(undefined, this.tresPuntosCodigoOperacion.filaSeleccionada, 1, true, this.mRowDataOperacion.Control);
    matriz.Renglon = ClsUtil.generarRenglon(this.gridOperacion.groupingFlatResult);
    this.mObjMatrices.gridMatriz = this.gridOperacion;
    this.mObjMatrices.updateCell(matriz, this.mRowDataOperacion.Control);
    this.mRowDataOperacion.Codigo = matriz.Codigo;
    this.tresPuntosCodigoOperacion.inputCatalogos.focus();
  }

  public cambioValorCodigoOperacion(e: TresPuntosComponent) {
    this.tresPuntosCodigoOperacion = e;
    this.gridOperacion.updateCell(this.tresPuntosCodigoOperacion.inputCatalogos.value.toUpperCase(), this.mRowDataOperacion.Control, 'Codigo');
  }

  public inicializarComponenteUnidadOperacion(e: TresPuntosComponent) {
    this.tresPuntosUnidadOperacion = e;
    this.gridOperacion.updateCell(this.tresPuntosUnidadOperacion.valorDefault.toString().toUpperCase(), this.mRowDataOperacion.Control, 'Unidad');
    this.tresPuntosUnidadOperacion.inputCatalogos.focus();
  }

  public cambioValorUnidadOperacion(e: TresPuntosComponent) {
    this.tresPuntosUnidadOperacion = e;
    this.gridOperacion.updateCell(this.tresPuntosUnidadOperacion.valorDefault.toString().toUpperCase(), this.mRowDataOperacion.Control, 'Unidad');
    this.tresPuntosUnidadOperacion.inputCatalogos.focus();
  }

  public get hasTransactionsOtroCons(): boolean {
    return this.gridOtrosConsumos.transactions.getAggregatedChanges(false).length > 0;
  }

  public rowEditEnterOtroCons(evt: IGridEditEventArgs) {
    if (evt.isAddRow && this.gridOtrosConsumos.groupingFlatResult.length === 3) {
      this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsSubject('MENSAJES.ALERT.CH_MAXIMO_REGISTROS').replace('{0}', '3'));
      evt.cancel = true;
      this.gridOtrosConsumos.transactions.clear(evt.rowKey);
      return;
    }
    this.showActionStripOtrosConsumos = false;
    this.mRowDataOtrosConsumos = evt.rowData;
  }

  public rowEditExitOtroCons() {
    this.showActionStripOtrosConsumos = true;
    if (ClsUtil.esNulo(this.mRowDataOtrosConsumos.Codigo)) {
      this.gridOtrosConsumos.transactions.clear(this.mRowDataOtrosConsumos.Control);
      const index: any = this.gridOtrosConsumos.groupingFlatResult.findIndex(value => value.Control === this.mRowDataOtrosConsumos.Control);
      this.gridOtrosConsumos.groupingFlatResult.splice(index, 1);
    }
    this.vaciaOtrosConsumosAExcel();
    this.regresaDatosExcel();
  }

  public async commitOtrosCons(saveBD = false) {
    if (ClsUtil.esNulo(this.expInsCF) && saveBD) {
      await new Promise(resolve => this.tipoMsg.mostrarMsgPromise((resp: any) => resolve(resp), 'MENSAJES.ALERT.VALIDAR_CF_CH', undefined, 'error')).then(value => value);
      this.tabGeneral.selectedIndex = 0;
      this.tresPuntosCFA.inputCatalogos.focus();
      return;
    }
    if (saveBD) {
      this.tipoMsg.mostrarQuestion(async (resp: boolean) => {
        if (resp) {
          try {
            this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.GUARDANDO_DATOS');
            this.gridOtrosConsumos.transactions.commit(this.gridOtrosConsumos.data);
            this.vaciaOtrosConsumosAExcel();
            this.regresaDatosExcel();
            const catExpIns = ClsUtil.getPptoCompletoActivoMaestroJSON(this.infPpto).CatExpIns;
            const allExpInsCopy: ClsCatalogosExpIns[] = catExpIns.map(x => ({...x}));
            // Snapshot solo para comparar "antes" vs "después" (no va al Map)
            const allExpInsAntes: ClsCatalogosExpIns[] = allExpInsCopy.map((x) => ({ ...x }));
            const mapCatalogo: Map<string, ClsCatalogosExpIns> = ClsUtil.crearMapCatalogoCodigo(allExpInsCopy);
            this.mObjCostoHorario.LsCostosHorariosOC = await this.guardarGridsBD(this.gridOtrosConsumos, false, mapCatalogo, allExpInsAntes);
            await this.mObjCH.registraActualizaCostoHorario([this.mObjCostoHorario]);
          } catch (e) {
            this.restaurarGridsSiFallaAlGuardar(this.gridOtrosConsumos);
            this.tipoMsg.mostrarMsg(e.message);
          } finally {
            this.tipoMsg.cerrarWaitDialog();
          }
        }
      }, this.mObjGenerico.getTranslationsSubject('MENSAJES.QUESTION.GUARDAR_CH'));
    } else {
      this.gridOtrosConsumos.transactions.commit(this.gridOtrosConsumos.data);
      this.vaciaOtrosConsumosAExcel();
      this.regresaDatosExcel();
    }
  }

  public undoOtrosCons() {
    this.gridOtrosConsumos.transactions.undo();
    this.vaciaOtrosConsumosAExcel();
    this.regresaDatosExcel();
  }

  public redoOtrosCons() {
    this.gridOtrosConsumos.transactions.redo();
    this.vaciaOtrosConsumosAExcel();
    this.regresaDatosExcel();
  }

  public discardOtrosCons() {
    this.tipoMsg.mostrarQuestion((resp: boolean) => {
      if (resp) {
        this.gridOtrosConsumos.transactions.clear();
        this.vaciaOtrosConsumosAExcel();
        this.regresaDatosExcel();
      }
    }, 'MENSAJES.QUESTION.CANCELAR_CAMBIOS');
  }

  public borrarOtrosCons(registro: any) {
    registro.delete();
    this.vaciaOtrosConsumosAExcel();
    this.regresaDatosExcel();
  }

  public async handleCellEdit(event: IGridEditEventArgs, grid: IgxGridComponent, rowData: ClsDetalleMatrizInsumos, tresPuntosCodigo: TresPuntosComponent, tresPuntosUnidad: TresPuntosComponent, operador: boolean) {
    let newValue: any = event.newValue;
    try {
      switch (event.column.field) {
        case 'Codigo':
          if (ClsUtil.esNulo(rowData.Codigo) || rowData.Codigo !== newValue) {
            try {
              ClsUtil.validarCampoVacio(newValue, this.mObjGenerico, 'GRIDS.EXP_INSUMO.COL_CODIGO');
              let expIns: ClsCatalogosExpIns = this.mObjExpInsumos.buscarCodigoEnExpIns(newValue);
              // si es Nulo, buscamos si existe en el tab de Datos y tab operacion
              expIns = ClsUtil.esNulo(expIns) ? this.buscarTabDatosOperacionSiExisteCodigo(newValue, operador) : expIns;
              // validamos si es operador = true, y en caso de encontrar el codigo en tab datos o tab otros consumos
              // mandar mensaje de que existe con tipo 1 y no es permitido agregarlo
              if (operador && !ClsUtil.esNulo(expIns) && expIns.Tipo !== 2) {
                let mensaje: string = this.mObjGenerico.getTranslationsSubject('MENSAJES.ALERT.VALIDAR_ADD_REGISTRO_CH');
                mensaje = mensaje.replace('{0}', newValue).replace('{1}', expIns.Tipo.toString());
                throw new Error(mensaje);
              }
              // si es Nulo, creamos obj con valores default, como si estuviera agregando el registro desde el catalogo general
              if (ClsUtil.esNulo(expIns)) {
                try {
                  event.cancel = true;
                  expIns = this.mObjExpInsumos.inicializarAsignarRegistro(undefined);
                  expIns.Codigo = newValue;
                  // si es true, indica que vienen del grid operacion, ya que ahi se maneja /
                  expIns.Tipo = operador ? 2 : expIns.Tipo;
                  if (this.mObjCH.validarOperacionOtrosConsumos(grid.groupingFlatResult, expIns, this.filaSeleccionado.Codigo, false)) {
                    event.cancel = await new Promise<boolean>(resolve => this.tipoMsg.mostrarQuestion((resp2: boolean) => resolve(resp2), this.mObjGenerico.getTranslationsMensajes('MENSAJES.QUESTION.AGREGAR_REGISTRO_COD_NUEVO').replace('{0}', newValue))).then(value => value);
                    if (event.cancel) {
                      this.inicializarRegistro(expIns, grid, rowData, operador);
                    } else {
                      grid.updateCell('', rowData.Control, 'Codigo');
                      tresPuntosCodigo.inputCatalogos.focus();
                    }
                  }
                } catch (e) {
                  event.cancel = true;
                  grid.updateCell('', rowData.Control, 'Codigo');
                  await new Promise(resolve => this.tipoMsg.mostrarMsgPromise((resp) => resolve(resp), e.message, undefined, 'error')).then(value => value);
                } finally {
                  tresPuntosCodigo.inputCatalogos.focus();
                }
              } else {
                if (!ClsUtil.esNulo(expIns) && this.mObjCH.validarOperacionOtrosConsumos(grid.groupingFlatResult, expIns, this.filaSeleccionado.Codigo, false)) {
                  this.inicializarRegistro(expIns, grid, rowData, operador);
                }
              }
            } catch (e) {
              event.cancel = true;
              grid.updateCell('', rowData.Control, 'Codigo');
              await new Promise(resolve => this.tipoMsg.mostrarMsgPromise((resp) => resolve(resp), e.message, undefined, 'error')).then(value => value);
            } finally {
              tresPuntosCodigo.inputCatalogos.focus();
            }
          }
          break;
        case 'DescripcionLarga':
          try {
            ClsUtil.validarCampoVacio(newValue, this.mObjGenerico, 'GRIDS.EXP_INSUMO.COL_DESCRIPCION_LARGA');
          } catch (e) {
            event.cancel = true;
            throw new Error(e.message);
          }
          break;
        case 'Unidad':
          try {
            ClsUtil.validarCampoVacio(newValue, this.mObjGenerico, 'GRIDS.EXP_INSUMO.COL_UNIDAD');
          } catch (e) {
            event.cancel = true;
            throw new Error(e.message);
          }
          break;
        case 'Volumen':
          try {
            ClsUtil.validarCampoVacioStartsWith(newValue, this.mObjGenerico, 'GRIDS.MATRIZ.COL_CANT');
            newValue = ClsUtil.evaluadorExpresiones(newValue, this.infPpto.decimalredondearmatrices);
            if (newValue <= 0) {
              throw new Error('MENSAJES.GRALS.CANTIDAD_MAYOR_0');
            }
          } catch (e) {
            event.cancel = true;
            throw new Error(e.message);
          }
          break;
        case 'CostoMoneda1':
          try {
            ClsUtil.validarCampoVacioStartsWith(newValue, this.mObjGenerico, 'GRIDS.EXP_INSUMO.COL_COSTO_M1');
          } catch (e) {
            event.cancel = true;
            throw new Error(e.message);
          }
          break;
        case 'CostoMoneda2':
          try {
            ClsUtil.validarCampoVacioStartsWith(newValue, this.mObjGenerico, 'GRIDS.EXP_INSUMO.COL_COSTO_M2');
          } catch (e) {
            event.cancel = true;
            throw new Error(e.message);
          }
          break;
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public buscarTabDatosOperacionSiExisteCodigo(codigo: string, esOperacion: boolean): ClsCatalogosExpIns {
    let codigoExiste: ClsDetalleMatrizInsumos;
    if (!ClsUtil.esNulo(this.expInsCF)) {
      if (this.expInsCF.Codigo === codigo) {
        return this.expInsCF;
      }
    }
    if (!ClsUtil.esNulo(this.expInsE)) {
      if (this.expInsE.Codigo === codigo) {
        return this.expInsE;
      }
    }
    if (!ClsUtil.esNulo(this.expInsR)) {
      if (this.expInsR.Codigo === codigo) {
        return this.expInsR;
      }
    }
    if (!ClsUtil.esNulo(this.expInsVA)) {
      if (this.expInsVA.Codigo === codigo) {
        return this.expInsVA;
      }
    }
    if (!ClsUtil.esNulo(this.expInsLl)) {
      if (this.expInsLl.Codigo === codigo) {
        return this.expInsLl;
      }
    }
    if (!ClsUtil.esNulo(this.expInsPE)) {
      if (this.expInsPE.Codigo === codigo) {
        return this.expInsPE;
      }
    }
    if (!ClsUtil.esNulo(this.expInsC)) {
      if (this.expInsC.Codigo === codigo) {
        return this.expInsC;
      }
    }
    if (!ClsUtil.esNulo(this.expInsL)) {
      if (this.expInsL.Codigo === codigo) {
        return this.expInsL;
      }
    }
    if (!ClsUtil.esNulo(this.expInsOFE)) {
      if (this.expInsOFE.Codigo === codigo) {
        return this.expInsOFE;
      }
    }
    // si esOperaciones false, indica que esta agregando en el grid de otros consumos
    if (!esOperacion) {
      if (this.gridOperacion.data.length > 0) {
        codigoExiste = this.gridOperacion.data.find(value => value.Codigo === codigo);
        if (!ClsUtil.esNulo(codigoExiste)) {
          const expInsExisteOpe: ClsCatalogosExpIns = this.mObjExpInsumos.inicializarAsignarRegistro(undefined);
          expInsExisteOpe.Codigo = codigo;
          expInsExisteOpe.Descripcion = codigoExiste.Descripcion;
          expInsExisteOpe.DescripcionLarga = codigoExiste.DescripcionLarga;
          expInsExisteOpe.Unidad = codigoExiste.Unidad;
          expInsExisteOpe.CostoMoneda1 = codigoExiste.CostoMoneda1;
          expInsExisteOpe.CostoMoneda2 = codigoExiste.CostoMoneda2;
          expInsExisteOpe.Tipo = codigoExiste.TipoInsumo;
          return expInsExisteOpe;
        }
      }
    }
    // si esOperaciones true, indica que esta agregando en el grid de operacion
    if (esOperacion) {
      if (this.gridOtrosConsumos.data.length > 0) {
        codigoExiste = this.gridOtrosConsumos.data.find(value => value.Codigo === codigo);
        if (!ClsUtil.esNulo(codigoExiste)) {
          const expInsExisteOpe: ClsCatalogosExpIns = this.mObjExpInsumos.inicializarAsignarRegistro(undefined);
          expInsExisteOpe.Codigo = codigo;
          expInsExisteOpe.Descripcion = codigoExiste.Descripcion;
          expInsExisteOpe.DescripcionLarga = codigoExiste.DescripcionLarga;
          expInsExisteOpe.Unidad = codigoExiste.Unidad;
          expInsExisteOpe.CostoMoneda1 = codigoExiste.CostoMoneda1;
          expInsExisteOpe.CostoMoneda2 = codigoExiste.CostoMoneda2;
          expInsExisteOpe.Tipo = codigoExiste.TipoInsumo;
          return expInsExisteOpe;
        }
      }
    }
    return undefined;
  }

  public cellEditDone(event: IGridEditDoneEventArgs, grid: IgxGridComponent, tresPuntosCodigo: TresPuntosComponent, rowData: ClsDetalleMatrizInsumos) {
    const rowId: any = event.rowKey;
    const tipoOperacion = event.rowData.TipoOperacion;
    let cantidad = event.rowData.Volumen;
    let costoMoneda1 = ClsUtil.esNulo(event.rowData.CostoMoneda1) ? 0 : event.rowData.CostoMoneda1;
    let costoMoneda2 = ClsUtil.esNulo(event.rowData.CostoMoneda2) ? 0 : event.rowData.CostoMoneda2;
    let newValue: any = event.newValue;
    let importe1: number;
    let importe2: number;
    try {
      switch (event.column.field) {
        case 'Codigo':
          break;
        case 'DescripcionLarga':
          grid.updateCell(newValue.toString().substring(0, 40), rowId, 'Descripcion');
          break;
        case 'Descripcion':
          grid.updateCell(newValue.toString(), rowId, 'Descripcion');
          break;
        case 'TipoOperacion':
          // costoMoneda1 = ClsUtil.redondearMoneda(ClsUtil.evaluadorExpresiones(costoMoneda1, this.infPpto.decimalredondearimporte), this.infPpto.decimalredondearimporte);
          // costoMoneda2 = ClsUtil.redondearMoneda(ClsUtil.evaluadorExpresiones(costoMoneda2, this.infPpto.decimalredondearimporte), this.infPpto.decimalredondearimporte);
          // cantidad = ClsUtil.evaluadorExpresiones(cantidad, this.infPpto.decimalredondearmatrices);
          // importe1 = ClsUtil.calcularImporteCadena(cantidad, costoMoneda1, newValue, this.infPpto.decimalredondearimporte);
          // importe2 = ClsUtil.calcularImporteCadena(cantidad, costoMoneda2, newValue, this.infPpto.decimalredondearimporte);
          // this.gridMatriz.updateCell(newValue === '/' ? true : false, rowId, 'Dividir');
          // this.gridMatriz.updateCell(importe1, rowId, 'ImporteMoneda1');
          // this.gridMatriz.updateCell(importe2, rowId, 'ImporteMoneda2');
          break;
        case 'Volumen':
          newValue = ClsUtil.evaluadorExpresiones(newValue, this.infPpto.decimalredondearmatrices);
          grid.updateCell(newValue, rowId, 'Volumen');
          costoMoneda1 = ClsUtil.redondearMoneda(ClsUtil.evaluadorExpresiones(costoMoneda1, this.infPpto.decimalredondearimporte), this.infPpto.decimalredondearimporte);
          costoMoneda2 = ClsUtil.redondearMoneda(ClsUtil.evaluadorExpresiones(costoMoneda2, this.infPpto.decimalredondearimporte), this.infPpto.decimalredondearimporte);
          importe1 = ClsUtil.calcularImporteCadena(newValue, costoMoneda1, tipoOperacion, this.infPpto.decimalredondearimporte);
          importe2 = ClsUtil.calcularImporteCadena(newValue, costoMoneda2, tipoOperacion, this.infPpto.decimalredondearimporte);
          grid.updateCell(importe1, rowId, 'ImporteMoneda1');
          grid.updateCell(importe2, rowId, 'ImporteMoneda2');
          break;
        case 'CostoMoneda1':
          newValue = ClsUtil.evaluadorExpresiones(newValue, this.infPpto.decimalredondearimporte);
          grid.updateCell(newValue, rowId, 'CostoMoneda1');
          cantidad = ClsUtil.evaluadorExpresiones(cantidad, this.infPpto.decimalredondearmatrices);
          importe1 = ClsUtil.calcularImporteCadena(cantidad, newValue, tipoOperacion, this.infPpto.decimalredondearimporte);
          importe2 = ClsUtil.calcularImporteCadena(cantidad, newValue, tipoOperacion, this.infPpto.decimalredondearimporte);
          grid.updateCell(importe1, rowId, 'ImporteMoneda1');
          grid.updateCell(importe2, rowId, 'ImporteMoneda2');
          break;
        case 'CostoMoneda2':
          newValue = ClsUtil.evaluadorExpresiones(newValue, this.infPpto.decimalredondearimporte);
          grid.updateCell(newValue, rowId, 'CostoMoneda2');
          cantidad = ClsUtil.evaluadorExpresiones(cantidad, this.infPpto.decimalredondearmatrices);
          importe1 = ClsUtil.calcularImporteCadena(cantidad, newValue, tipoOperacion, this.infPpto.decimalredondearimporte);
          importe2 = ClsUtil.calcularImporteCadena(cantidad, newValue, tipoOperacion, this.infPpto.decimalredondearimporte);
          grid.updateCell(importe1, rowId, 'ImporteMoneda1');
          grid.updateCell(importe2, rowId, 'ImporteMoneda2');
          break;
        case 'ImporteMoneda1':
          // newValue = ClsUtil.redondearMoneda(ClsUtil.evaluadorExpresiones(newValue, this.infPpto.decimalredondearimporte), this.infPpto.decimalredondearimporte);
          // this.gridMatriz.updateCell(newValue, rowId, 'ImporteMoneda1');
          // costoMoneda1 = ClsUtil.redondearMoneda(ClsUtil.evaluadorExpresiones(costoMoneda1, this.infPpto.decimalredondearimporte), this.infPpto.decimalredondearimporte);
          // importe1 = ClsUtil.calcularCantidad(newValue, costoMoneda1, tipoOperacion, this.infPpto.decimalredondearmatrices);
          // this.gridMatriz.updateCell(importe1, rowId, 'Volumen');
          break;
        case 'ImporteMoneda2':
          // newValue = ClsUtil.redondearMoneda(ClsUtil.evaluadorExpresiones(newValue, this.infPpto.decimalredondearimporte), this.infPpto.decimalredondearimporte);
          // this.gridMatriz.updateCell(newValue, rowId, 'ImporteMoneda2');
          // costoMoneda2 = ClsUtil.redondearMoneda(ClsUtil.evaluadorExpresiones(costoMoneda2, this.infPpto.decimalredondearimporte), this.infPpto.decimalredondearimporte);
          // importe2 = ClsUtil.calcularCantidad(newValue, costoMoneda2, tipoOperacion, this.infPpto.decimalredondearmatrices);
          // this.gridMatriz.updateCell(importe2, rowId, 'Volumen');
          break;
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public inicializarRegistro(expIns: ClsCatalogosExpIns, grid: IgxGridComponent, rowData: ClsDetalleMatrizInsumos, operador: boolean, volumen = 1, renglon = 0, nuevo = false) {
    try {
      const matriz = this.mObjMatrices.inicializarInsumo(undefined, expIns, volumen, operador, rowData.Control);
      matriz.Renglon = (renglon === 0) ? ClsUtil.generarRenglon(grid.groupingFlatResult) : renglon;
      if (nuevo) {
        grid.addRow(matriz);
      } else {
        this.mObjMatrices.gridMatriz = grid;
        this.mObjMatrices.updateCell(matriz, rowData.Control);
      }
      rowData.Codigo = matriz.Codigo;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public inicializarComponenteCodigoOtroCons(e: TresPuntosComponent) {
    this.tresPuntosCodigoOtroCons = e;
    const matriz = this.mObjMatrices.inicializarInsumo(undefined, this.tresPuntosCodigoOtroCons.filaSeleccionada, 1, false, this.mRowDataOtrosConsumos.Control);
    matriz.Renglon = ClsUtil.generarRenglon(this.gridOtrosConsumos.groupingFlatResult);
    this.mObjMatrices.gridMatriz = this.gridOtrosConsumos;
    this.mObjMatrices.updateCell(matriz, this.mRowDataOtrosConsumos.Control);
    this.mRowDataOtrosConsumos.Codigo = matriz.Codigo;
    this.tresPuntosCodigoOtroCons.inputCatalogos.focus();
  }

  public cambioValorCodigoOtroCons(e: TresPuntosComponent) {
    this.tresPuntosCodigoOtroCons = e;
    this.gridOtrosConsumos.updateCell(this.tresPuntosCodigoOtroCons.inputCatalogos.value.toUpperCase(), this.mRowDataOtrosConsumos.Control, 'Codigo');
  }

  public inicializarComponenteUnidadOtroCons(e: TresPuntosComponent) {
    this.tresPuntosUnidadOtroCons = e;
    this.gridOtrosConsumos.updateCell(this.tresPuntosUnidadOtroCons.valorDefault.toString().toUpperCase(), this.mRowDataOtrosConsumos.Control, 'Unidad');
    this.tresPuntosUnidadOtroCons.inputCatalogos.focus();
  }

  public cambioValorUnidadOtroCons(e: TresPuntosComponent) {
    this.tresPuntosUnidadOtroCons = e;
    this.gridOtrosConsumos.updateCell(this.tresPuntosUnidadOtroCons.valorDefault.toString().toUpperCase(), this.mRowDataOtrosConsumos.Control, 'Unidad');
    this.tresPuntosUnidadOtroCons.inputCatalogos.focus();
  }

  // ocultar las hojas de campos generales y datos
  // bloquear libro y hojas
  private async bloquearCargarValidarLibro(file: File): Promise<Workbook> {
    const libro: Workbook = await this.mObjCH.validarSetIndexHojasCHDefault(file);
    this.mHojaCamposGenerales = libro.worksheets(this.mObjCH.IndiceHojaCamposGenerales);
    this.mHojaDatos = libro.worksheets(this.mObjCH.IndiceHojaDatos);
    this.mHojaCalculo = libro.worksheets(this.mObjCH.IndiceHojaCalculo);
    if (this.mObjCH.IndiceHojaCamposGenerales !== -1) {
      libro.worksheets(this.mObjCH.IndiceHojaCamposGenerales).protect(false, false, false, false, false, false, false, false, false, false, false, false, false);
    }
    if (this.mObjCH.IndiceHojaDatos !== -1) {
      libro.worksheets(this.mObjCH.IndiceHojaDatos).protect(false, false, false, false, false, false, false, false, false, false, false, false, false);
    }
    if (this.mObjCH.IndiceHojaCalculo !== -1) {
      libro.worksheets(this.mObjCH.IndiceHojaCalculo).protect(false, false, false, false, false, false, false, false, false, false, false, false, false);
    }
    if (this.mObjCH.IndiceHojaSoloActivo !== -1) {
      libro.worksheets(this.mObjCH.IndiceHojaSoloActivo).protect(false, false, false, false, false, false, false, false, false, false, false, false, false);
    }
    libro.protect(false, false);
    return libro;
  }

  private limpiarLibroDatosGenerales() {
    try {
      this.mHojaCamposGenerales.unprotect();
      this.mHojaCamposGenerales.getCell('area').value = '';
      this.mHojaCamposGenerales.getCell('ciudad').value = '';
      this.mHojaCamposGenerales.getCell('cmic').value = '';
      this.mHojaCamposGenerales.getCell('cargo').value = '';
      this.mHojaCamposGenerales.getCell('cargoresponsabledelaobra').value = '';
      this.mHojaCamposGenerales.getCell('ciudadcliente').value = '';
      this.mHojaCamposGenerales.getCell('ciudaddelaobra').value = '';
      this.mHojaCamposGenerales.getCell('codigopostalcliente').value = '';
      this.mHojaCamposGenerales.getCell('codigopostaldelaobra').value = '';
      this.mHojaCamposGenerales.getCell('colonia').value = '';
      this.mHojaCamposGenerales.getCell('coloniacliente').value = '';
      this.mHojaCamposGenerales.getCell('coloniadelaobra').value = '';
      this.mHojaCamposGenerales.getCell('contactocliente').value = '';
      this.mHojaCamposGenerales.getCell('direcciondeconcurso').value = '';
      this.mHojaCamposGenerales.getCell('decimalesredondeo').value = 0;
      this.mHojaCamposGenerales.getCell('domicilio').value = '';
      this.mHojaCamposGenerales.getCell('departamento').value = '';
      this.mHojaCamposGenerales.getCell('direcciondelaobra').value = '';
      this.mHojaCamposGenerales.getCell('direccioncliente').value = '';
      this.mHojaCamposGenerales.getCell('estadodelaobra').value = '';
      this.mHojaCamposGenerales.getCell('email').value = '';
      this.mHojaCamposGenerales.getCell('emailcliente').value = '';
      this.mHojaCamposGenerales.getCell('emaildelaobra').value = '';
      this.mHojaCamposGenerales.getCell('estado').value = '';
      this.mHojaCamposGenerales.getCell('fechainicio').value = '';
      this.mHojaCamposGenerales.getCell('fechaterminacion').value = '';
      this.mHojaCamposGenerales.getCell('fechadeconcurso').value = '';
      this.mHojaCamposGenerales.getCell('fechaconvocatoria').value = '';
      this.mHojaCamposGenerales.getCell('infonavit').value = '';
      this.mHojaCamposGenerales.getCell('imss').value = '';
      this.mHojaCamposGenerales.getCell('nombrecliente').value = '';
      this.mHojaCamposGenerales.getCell('nombredelaobra').value = '';
      this.mHojaCamposGenerales.getCell('numerodeconcurso').value = '';
      this.mHojaCamposGenerales.getCell('numconvocatoria').value = '';
      this.mHojaCamposGenerales.getCell('plazocalculado').value = 0;
      this.mHojaCamposGenerales.getCell('plazoreal').value = 0;
      this.mHojaCamposGenerales.getCell('porcentajeivapresupuesto').value = 0;
      this.mHojaCamposGenerales.getCell('primeramoneda').value = 0;
      this.mHojaCamposGenerales.getCell('rfc').value = '';
      this.mHojaCamposGenerales.getCell('razonsocial').value = '';
      this.mHojaCamposGenerales.getCell('responsable').value = '';
      this.mHojaCamposGenerales.getCell('remateprimeramoneda').value = '';
      this.mHojaCamposGenerales.getCell('rematesegundamoneda').value = '';
      this.mHojaCamposGenerales.getCell('responsabledelaobra').value = '';

      this.mHojaCamposGenerales.getCell('segundamoneda').value = '';
      this.mHojaCamposGenerales.getCell('totalpresupuestoprimeramoneda').value = 0;
      this.mHojaCamposGenerales.getCell('totalpresupuestosegundamoneda').value = 0;
      this.mHojaCamposGenerales.getCell('telefono').value = '';
      this.mHojaCamposGenerales.getCell('telefonocliente').value = '';
      this.mHojaCamposGenerales.getCell('telefonodelaobra').value = '';
      this.mHojaCamposGenerales.getCell('tipodelicitacion').value = '';

      this.mHojaDatos.getCell('DepreciacionE_Procentaje').value = 0;
      this.mHojaDatos.getCell('DepreciacionR_Porcentaje').value = 0;
      this.mHojaDatos.getCell('InversionE_Porcentaje').value = 0;
      this.mHojaDatos.getCell('InversionR_Porcentaje').value = 0;
      this.mHojaDatos.getCell('SegurosE_Porcentaje').value = 0;
      this.mHojaDatos.getCell('SegurosR_Porcentaje').value = 0;
      this.mHojaDatos.getCell('MantenimientoE_Porcentaje').value = 0;
      this.mHojaDatos.getCell('MantenimientoR_Porcentaje').value = 0;
      this.mHojaDatos.getCell('CombustibleE_Porcentaje').value = 0;
      this.mHojaDatos.getCell('CombustibleR_Porcentaje').value = 0;
      this.mHojaDatos.getCell('LubricanteE_Porcentaje').value = 0;
      this.mHojaDatos.getCell('LubricanteR_Porcentaje').value = 0;
      this.mHojaDatos.getCell('LlantasE_Porcentaje').value = 0;
      this.mHojaDatos.getCell('LlantasR_Porcentaje').value = 0;
      this.mHojaDatos.getCell('OperacionE_Porcentaje').value = 0;
      this.mHojaDatos.getCell('OperacionR_Porcentaje').value = 0;
      this.mHojaDatos.getCell('PiezasE_Porcentaje').value = 0;
      this.mHojaDatos.getCell('PiezasR_Porcentaje').value = 0;
      // Este es fijo porque en el sistema no hay un lugar para capturarlo
      this.mHojaDatos.getCell('OtraFuentesE_Porcentaje').value = 0.05;
      this.mHojaDatos.getCell('OtraFuentesR_Porcentaje').value = 0;
    } catch (e) {
      throw new Error(e.message);
    } finally {
      this.mHojaDatos.protect(false, false, false, false, false, false, false, false, false, false, false, false, false);
    }
  }

  private limpiaLibroDatosParticulares() {
    try {
      this.mHojaDatos.unprotect();
      this.mHojaDatos.getCell('CodigoEquipo').value = '';
      this.mHojaDatos.getCell('DescripcionEquipo').value = '';
      this.mHojaDatos.getCell('Modelo').value = '';
      this.mHojaDatos.getCell('NumeroDeSerie').value = '';
      this.mHojaDatos.getCell('Capacidad').value = '';
      this.mHojaDatos.getCell('PrecioAdquisicion').value = 0;
      this.mHojaDatos.getCell('PrecioLlantas').value = 0;
      this.mHojaDatos.getCell('VidaEcoLlantasHrs').value = 0;
      this.mHojaDatos.getCell('CostoPzsEsp').value = 0;
      this.mHojaDatos.getCell('VidaEcoPiezasHrs').value = 0;
      this.mHojaDatos.getCell('ValorRescate').value = 0;
      this.mHojaDatos.getCell('TasaInteres').value = 0;
      this.mHojaDatos.getCell('PrimaSeguros').value = 0;
      this.mHojaDatos.getCell('HorasXAño').value = 0;
      this.mHojaDatos.getCell('VidaEcoEQHrs').value = 0;
      this.mHojaDatos.getCell('PotenciaNominal').value = 0;
      this.mHojaDatos.getCell('CostoCombustible').value = 0;
      this.mHojaDatos.getCell('Combustible').value = '';
      this.mHojaDatos.getCell('CostoLubricante').value = 0;
      this.mHojaDatos.getCell('FactorOperacion').value = 0;
      this.mHojaDatos.getCell('FactorMantenimiento').value = 0;
      this.mHojaDatos.getCell('CostoOtrasFuentes').value = 0;
      this.mHojaDatos.getCell('FactorOtrasFuentes').value = 0;
      this.mHojaDatos.getCell('CostoOtrasFuentes').value = 0;
      this.mHojaDatos.getCell('OtrasFuentesDeEnergia').value = '';
      this.mHojaDatos.getCell('ConsumosDetallado').value = 1;
      this.mHojaDatos.getCell('FactorCombustible').value = 0;
      this.mHojaDatos.getCell('FactorLubricante').value = 0;
      this.mHojaDatos.getCell('CapacidadCarter').value = 0;
      this.mHojaDatos.getCell('TiempoCambioLub').value = 0;
      this.mHojaDatos.getCell('CantidadCombustible_sinDetalle').value = 0;
      this.mHojaDatos.getCell('CantidadLubricante_sinDetalle').value = 0;
      this.mHojaDatos.getCell('ExplotarInsumosCH').value = 0;
      // ESTE DATO SE CALCULA EN LA HOJA DE EXCEL
      this.mHojaDatos.getCell('PrecioEquipoAdicional').value = 0;
      // LIMPIA EL CUADRO DE OPERACIÓN
      this.limpiaDatosOperacion();
      // LIMPIA EL CUADRO DE OTROS CONSUMOS
      this.limpiaDatosOtrosConsumos();
    } catch (e) {
      throw new Error(e.message);
    } finally {
      this.mHojaDatos.protect(false, false, false, false, false, false, false, false, false, false, false, false, false);
    }
  }

  private limpiaDatosOperacion() {
    let fila = 0;
    let columna = 0;
    fila = this.mHojaDatos.getCell('InicioOperacion').rowIndex;
    columna = this.mHojaDatos.getCell('InicioOperacion').columnIndex;
    for (let i = 0; i <= (this.mObjCH.mMaximoMo - 1); i++) {
      this.mHojaDatos.rows(fila + 1).cells(columna).value = '';
      this.mHojaDatos.rows(fila + 1).cells(columna + 1).value = '';
      this.mHojaDatos.rows(fila + 1).cells(columna + 2).value = '';
      this.mHojaDatos.rows(fila + 1).cells(columna + 3).value = '';
      this.mHojaDatos.rows(fila + 1).cells(columna + 4).value = 0;
      this.mHojaDatos.rows(fila + 1).cells(columna + 5).value = 0;
      this.mHojaDatos.rows(fila + 1).cells(columna + 6).value = 0;
      fila += 1;
    }
  }

  private limpiaDatosOtrosConsumos() {
    let fila = 0;
    let columna = 0;
    fila = this.mHojaDatos.getCell('InicioOtrosConsumos').rowIndex;
    columna = this.mHojaDatos.getCell('InicioOtrosConsumos').columnIndex;
    for (let i = 0; i <= (this.mObjCH.mMaximoOc - 1); i++) {
      this.mHojaDatos.rows(fila + 1).cells(columna).value = '';
      this.mHojaDatos.rows(fila + 1).cells(columna + 1).value = '';
      this.mHojaDatos.rows(fila + 1).cells(columna + 2).value = '';
      this.mHojaDatos.rows(fila + 1).cells(columna + 3).value = '';
      this.mHojaDatos.rows(fila + 1).cells(columna + 4).value = 0;
      this.mHojaDatos.rows(fila + 1).cells(columna + 5).value = 0;
      this.mHojaDatos.rows(fila + 1).cells(columna + 6).value = '';
      this.mHojaDatos.rows(fila + 1).cells(columna + 7).value = 0;
      fila += 1;
    }
  }

  private async enviaParametrosGenerales() {
    try {
      // obtener map de campos generales
      await ClsUtil.obtenerEncabezadoReporte(this.infPpto, this.mObjCatalogoPptosGrals, this.mObjGenerico);
      // envia todos los datos generales a la hoja de campos generales
      this.infPpto.mapCamposGenerales.forEach((value, key) => {
        this.validaCampoGeneral(key, value);
      });
      //  envia los % de espera y reserva
      this.validaValorDatos('DepreciacionE_Procentaje', Number(this.infPpto.parametrosPpto.find(para => para.Parametro === EnumParaPpto.CHDEPRECIACIONE).Valor) / 100);
      this.validaValorDatos('DepreciacionR_Porcentaje', Number(this.infPpto.parametrosPpto.find(para => para.Parametro === EnumParaPpto.CHDEPRECIACIONR).Valor) / 100);
      this.validaValorDatos('InversionE_Porcentaje', Number(this.infPpto.parametrosPpto.find(para => para.Parametro === EnumParaPpto.CHINVERSIONE).Valor) / 100);
      this.validaValorDatos('InversionR_Porcentaje', Number(this.infPpto.parametrosPpto.find(para => para.Parametro === EnumParaPpto.CHINVERSIONR).Valor) / 100);
      this.validaValorDatos('SegurosE_Porcentaje', Number(this.infPpto.parametrosPpto.find(para => para.Parametro === EnumParaPpto.CHSEGUROSE).Valor) / 100);
      this.validaValorDatos('SegurosR_Porcentaje', Number(this.infPpto.parametrosPpto.find(para => para.Parametro === EnumParaPpto.CHSEGUROSR).Valor) / 100);
      this.validaValorDatos('MantenimientoE_Porcentaje', Number(this.infPpto.parametrosPpto.find(para => para.Parametro === EnumParaPpto.CHMANTENIMIENTOE).Valor) / 100);
      this.validaValorDatos('MantenimientoR_Porcentaje', Number(this.infPpto.parametrosPpto.find(para => para.Parametro === EnumParaPpto.CHMANTENIMIENTOR).Valor) / 100);
      this.validaValorDatos('CombustibleE_Porcentaje', Number(this.infPpto.parametrosPpto.find(para => para.Parametro === EnumParaPpto.CHCOMBUSTIBLEE).Valor) / 100);
      this.validaValorDatos('CombustibleR_Porcentaje', Number(this.infPpto.parametrosPpto.find(para => para.Parametro === EnumParaPpto.CHCOMBUSTIBLER).Valor) / 100);
      this.validaValorDatos('LubricanteE_Porcentaje', Number(this.infPpto.parametrosPpto.find(para => para.Parametro === EnumParaPpto.CHLUBRICANTESE).Valor) / 100);
      this.validaValorDatos('LubricanteR_Porcentaje', Number(this.infPpto.parametrosPpto.find(para => para.Parametro === EnumParaPpto.CHLUBRICANTESR).Valor) / 100);
      this.validaValorDatos('LlantasE_Porcentaje', Number(this.infPpto.parametrosPpto.find(para => para.Parametro === EnumParaPpto.CHLLANTASE).Valor) / 100);
      this.validaValorDatos('LlantasR_Porcentaje', Number(this.infPpto.parametrosPpto.find(para => para.Parametro === EnumParaPpto.CHLLANTASR).Valor) / 100);
      this.validaValorDatos('PiezasE_Porcentaje', Number(this.infPpto.parametrosPpto.find(para => para.Parametro === EnumParaPpto.CHPIEZAESPE).Valor));
      this.validaValorDatos('PiezasR_Porcentaje', Number(this.infPpto.parametrosPpto.find(para => para.Parametro === EnumParaPpto.CHPIEZAESPR).Valor) / 100);
      this.validaValorDatos('OperacionE_Porcentaje', Number(this.infPpto.parametrosPpto.find(para => para.Parametro === EnumParaPpto.CHOPERACIONE).Valor) / 100);
      this.validaValorDatos('OperacionR_Porcentaje', Number(this.infPpto.parametrosPpto.find(para => para.Parametro === EnumParaPpto.CHOPERACIONR).Valor) / 100);
      this.validaValorDatos('OtraFuentesE_Porcentaje', Number(this.infPpto.parametrosPpto.find(para => para.Parametro === EnumParaPpto.CHOTRASFUENTESENERGIAE).Valor) / 100);
      this.validaValorDatos('OtraFuentesR_Porcentaje', Number(this.infPpto.parametrosPpto.find(para => para.Parametro === EnumParaPpto.CHOTRASFUENTESENERGIAR).Valor) / 100);
      this.validaValorDatos('IndicadorEconomicoReferencia', this.infPpto.parametrosPpto.find(para => para.Parametro === EnumParaPpto.CHINDREFERENCIA).Valor);
      this.validaValorDatos('IndicadorEspecificoMercado', this.infPpto.parametrosPpto.find(para => para.Parametro === EnumParaPpto.CHINDESPECIFICOSEGUROS).Valor);
    } catch (e) {
    }
  }

  // regresa los datos a la pantalla de costo horarios
  private regresaDatosExcel() {
    try {
      //  regresa datos calculados
      this.potenciaOpeTotal.value = ClsUtil.formatoMonedaPipeSinSimbolo$ConDecimal(ClsUtil.validaraMayorCero(this.mHojaDatos.getCell('PotenciaOperación').value));
      this.costoCFA.value = ClsUtil.formatoMonedaPipe(ClsUtil.validaraMayorCero(this.mHojaDatos.getCell('CostoCargoFijoA').value), this.formatDecImporte.digitsInfo);
      this.costoEspera.value = ClsUtil.formatoMonedaPipe(ClsUtil.validaraMayorCero(this.mHojaDatos.getCell('CostoEspera').value), this.formatDecImporte.digitsInfo);
      this.costoReserva.value = ClsUtil.formatoMonedaPipe(ClsUtil.validaraMayorCero(this.mHojaDatos.getCell('CostoReserva').value), this.formatDecImporte.digitsInfo);
      this.totalCF.value = ClsUtil.formatoMonedaPipe(ClsUtil.validaraMayorCero(this.mHojaDatos.getCell('CostoCargoFijoA').value), this.formatDecImporte.digitsInfo);
      this.valorMaquinaria.value = ClsUtil.formatoMonedaPipe(ClsUtil.validaraMayorCero(this.mHojaDatos.getCell('ValorMaquinaria').value), this.formatDecImporte.digitsInfo);
      this.depreciacion.value = ClsUtil.formatoMonedaPipe(ClsUtil.validaraMayorCero(this.mHojaDatos.getCell('DepreciacionA_Monto').value), this.formatDecImporte.digitsInfo);
      this.inversion.value = ClsUtil.formatoMonedaPipe(ClsUtil.validaraMayorCero(this.mHojaDatos.getCell('InversionA_Monto').value), this.formatDecImporte.digitsInfo);
      this.seguro.value = ClsUtil.formatoMonedaPipe(ClsUtil.validaraMayorCero(this.mHojaDatos.getCell('SegurosA_Monto').value), this.formatDecImporte.digitsInfo);
      this.mantenimiento.value = ClsUtil.formatoMonedaPipe(ClsUtil.validaraMayorCero(this.mHojaDatos.getCell('MantenimientoA_Monto').value), this.formatDecImporte.digitsInfo);
      this.consumoLts.value = ClsUtil.formatoMonedaPipeSinSimbolo$ConDecimal(ClsUtil.validaraMayorCero(this.mHojaDatos.getCell('CantidadCombustible').value), '1.4-4');
      //  obtiene los totales
      this.ttotalCF.value = ClsUtil.formatoMonedaPipe(ClsUtil.validaraMayorCero(this.mHojaDatos.getCell('CostoCargoFijoA').value), this.formatDecImporte.digitsInfo);
      this.ttotalOperacion.value = ClsUtil.formatoMonedaPipe(ClsUtil.validaraMayorCero(this.mHojaDatos.getCell('CostoOperacionA').value), this.formatDecImporte.digitsInfo);
      if (this.rTipoLubCom === '2') {
        this.combustibleXHora.value = ClsUtil.formatoMonedaPipeSinSimbolo$ConDecimal(ClsUtil.validaraMayorCero(this.mHojaDatos.getCell('CantidadCombustible').value), '1.4-4');
      }
      this.ttotalConsumos.value = ClsUtil.formatoMonedaPipe(ClsUtil.validaraMayorCero(this.mHojaDatos.getCell('CostoConsumoA').value), this.formatDecImporte.digitsInfo);
      this.totalLubricante.value = ClsUtil.formatoMonedaPipeSinSimbolo$ConDecimal(ClsUtil.validaraMayorCero(this.mHojaDatos.getCell('CantidadLubricante').value), '1.4-4');
      //  falta el costo total equipo
      this.ttotalCostoActivo.value = ClsUtil.formatoMonedaPipe(ClsUtil.validaraMayorCero(this.mHojaDatos.getCell('CostoActivo').value), this.formatDecImporte.digitsInfo);
      this.ttotalCostoEspera.value = ClsUtil.formatoMonedaPipe(ClsUtil.validaraMayorCero(this.mHojaDatos.getCell('CostoEspera').value), this.formatDecImporte.digitsInfo);
      this.ttotalCostoReserva.value = ClsUtil.formatoMonedaPipe(ClsUtil.validaraMayorCero(this.mHojaDatos.getCell('CostoReserva').value), this.formatDecImporte.digitsInfo);
    } catch (e) {
      throw new Error(e.message);
    }
  }

  private vaciaDatosDelEquipoAExcel() {
    try {
      this.validaValorDatos('CodigoEquipo', this.filaSeleccionado.Codigo);
      this.validaValorDatos('DescripcionEquipo', this.filaSeleccionado.DescripcionLarga);
      this.validaValorDatos('Modelo', ClsUtil.cadenaX(this.modelo.value));
      this.validaValorDatos('NumeroDeSerie', ClsUtil.cadenaX(this.numeroSerie.value));
      this.validaValorDatos('Capacidad', ClsUtil.cadenaX(this.capacidad.value));
      this.validaValorDatos('PrecioAdquisicion', ClsUtil.numberX(this.costoValorAdq.value, true));
      this.validaValorDatos('PrecioLlantas', ClsUtil.numberX(this.costoLlantas.value, true));
      this.validaValorDatos('VidaEcoLlantasHrs', ClsUtil.numberX(this.vidaEconomicaHrsLlantas.value, true));
      this.validaValorDatos('CostoPzsEsp', ClsUtil.numberX(this.costoPzaEsp.value, true));
      this.validaValorDatos('VidaEcoPiezasHrs', ClsUtil.numberX(this.vidaEconomicaHrsPzaEsp.value, true));
      this.validaValorDatos('ValorRescate', ClsUtil.numberX(this.valorRescatePor.value, true) / 100);
      this.validaValorDatos('TasaInteres', ClsUtil.numberX(this.tasaInteres.value, true) / 100);
      this.validaValorDatos('PrimaSeguros', ClsUtil.numberX(this.primaAnualProSeg.value, true) / 100);
      this.validaValorDatos('HorasXAño', ClsUtil.numberX(this.hrsTrabajadasXAnio.value, true));
      this.validaValorDatos('VidaEcoEQHrs', ClsUtil.numberX(this.cfVidaEconomicaHrs.value, true));
      this.validaValorDatos('PotenciaNominal', ClsUtil.numberX(this.potenciaValor.value, true));
      this.validaValorDatos('CostoCombustible', ClsUtil.numberX(this.costoCombustible.value, true));
      this.validaValorDatos('CostoLubricante', ClsUtil.numberX(this.costoLubricante.value, true));
      this.validaValorDatos('FactorOperacion', ClsUtil.numberX(this.factorOperacionPor.value, true) / 100);
      this.validaValorDatos('FactorMantenimiento', ClsUtil.numberX(this.factorMantenimiento.value, true));
      this.validaValorDatos('CostoOtrasFuentes', ClsUtil.numberX(this.costoOtrasFEnergia.value, true));
      this.validaValorDatos('FactorOtrasFuentes', ClsUtil.numberX(this.factorOtrasFuentes.value, true));
      // this.validaValorDatos('Combustible', '');
      // this.validaValorDatos('OtrasFuentesDeEnergia', '');
      this.validaValorDatos('Combustible', ClsUtil.cadenaX(this.desCombustible.value));
      this.validaValorDatos('OtrasFuentesDeEnergia', ClsUtil.cadenaX(this.desOtrasFEnergia.value));
    } catch (e) {
      throw new Error(e.message);
    }
  }

  private validaValorDatos(nomParametro: string, valor: any) {
    try {
      this.mHojaDatos.unprotect();
      this.mHojaDatos.getCell(nomParametro).value = valor;
    } catch (e) {
      throw new Error(e.message);
    } finally {
      this.mHojaDatos.protect(false, false, false, false, false, false, false, false, false, false, false, false, false);
    }
  }

  private enviarCostoAExcel(nomCampo: string, valor: number) {
    try {
      this.mHojaDatos.unprotect();
      this.mHojaDatos.getCell(nomCampo).value = valor;
    } catch (e) {
    } finally {
      this.mHojaDatos.protect(false, false, false, false, false, false, false, false, false, false, false, false, false);
    }
  }

  private validaCampoGeneral(nomParametro: string, valor: any) {
    try {
      this.mHojaCamposGenerales.unprotect();
      this.mHojaCamposGenerales.getCell(nomParametro).value = valor;
    } catch (e) {
    } finally {
      this.mHojaCamposGenerales.protect(false, false, false, false, false, false, false, false, false, false, false, false, false);
    }
  }

  private vaciaCostoDetallado() {
    try {
      if (this.rTipoLubCom === '1') {
        this.validaValorDatos('FactorCombustible', Number(this.factorCombustible.value));
        this.validaValorDatos('FactorLubricante', Number(this.factorLubricante.value));
        this.validaValorDatos('CapacidadCarter', Number(this.carterLts.value));
        this.validaValorDatos('TiempoCambioLub', Number(this.hrsCambio.value));
        this.validaValorDatos('ConsumosDetallado', 1);
      } else {
        this.validaValorDatos('ConsumosDetallado', 0);
        this.validaValorDatos('CantidadCombustible_sinDetalle', Number(this.combustibleXHora.value));
        this.validaValorDatos('CantidadLubricante_sinDetalle', Number(this.lubricanteXHora.value));
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public vaciaOperacionAExcel() {
    try {
      let fila = 0;
      let columna = 0;
      this.mHojaDatos.unprotect();
      fila = this.mHojaDatos.getCell('InicioOperacion').rowIndex;
      columna = this.mHojaDatos.getCell('InicioOperacion').columnIndex;
      this.limpiaDatosOperacion();
      this.gridOperacion.data.forEach(value => {
        this.mHojaDatos.rows(fila + 1).cells(columna).value = value.Codigo;
        this.mHojaDatos.rows(fila + 1).cells(columna + 1).value = value.DescripcionLarga;
        this.mHojaDatos.rows(fila + 1).cells(columna + 2).value = value.Descripcion;
        this.mHojaDatos.rows(fila + 1).cells(columna + 3).value = value.Unidad;
        this.mHojaDatos.rows(fila + 1).cells(columna + 4).value = value.Volumen;
        this.mHojaDatos.rows(fila + 1).cells(columna + 5).value = this.esMoneda1 ? value.CostoMoneda1 : value.CostoMoneda2;
        this.mHojaDatos.rows(fila + 1).cells(columna + 6).value = this.esMoneda1 ? value.ImporteMoneda1 : value.ImporteMoneda2;
        fila += 1;
      });
    } catch (e) {
      throw new Error(e.message);
    } finally {
      this.mHojaDatos.protect(false, false, false, false, false, false, false, false, false, false, false, false, false);
    }
  }

  public vaciaOtrosConsumosAExcel() {
    try {
      let fila = 0;
      let columna = 0;
      this.mHojaDatos.unprotect();
      fila = this.mHojaDatos.getCell('InicioOtrosConsumos').rowIndex;
      columna = this.mHojaDatos.getCell('InicioOtrosConsumos').columnIndex;
      this.limpiaDatosOtrosConsumos();
      this.gridOtrosConsumos.data.forEach(value => {
        this.mHojaDatos.rows(fila + 1).cells(columna).value = value.Codigo;
        this.mHojaDatos.rows(fila + 1).cells(columna + 1).value = value.DescripcionLarga;
        this.mHojaDatos.rows(fila + 1).cells(columna + 2).value = value.Descripcion;
        this.mHojaDatos.rows(fila + 1).cells(columna + 3).value = value.Unidad;
        this.mHojaDatos.rows(fila + 1).cells(columna + 4).value = value.Volumen;
        this.mHojaDatos.rows(fila + 1).cells(columna + 5).value = this.esMoneda1 ? value.CostoMoneda1 : value.CostoMoneda2;
        this.mHojaDatos.rows(fila + 1).cells(columna + 6).value = value.TipoOperacion;
        this.mHojaDatos.rows(fila + 1).cells(columna + 7).value = this.esMoneda1 ? value.ImporteMoneda1 : value.ImporteMoneda2;
        fila += 1;
      });
    } catch (e) {
      throw new Error(e.message);
    } finally {
      this.mHojaDatos.protect(false, false, false, false, false, false, false, false, false, false, false, false, false);
    }
  }

  // eventos hoja de calculo
  public activeWorksheetChanged(evt: any) {
    this.spreadsheet.activeWorksheet = this.spreadsheet.workbook.worksheets(evt.args.newValue.name);
    this.spreadsheet.activeCell = new SpreadsheetCell('A1');
  }

  public userPromptDisplaying(evt: any) {
    if (evt.args.message.includes("The cell you're trying to change is on a protected sheet.")) {
      this.tipoMsg.mostrarMsg('MENSAJES.GRALS.EXCEL_PROTEGIDO');
    } else {
      this.tipoMsg.mostrarMsg(evt.args.message);
    }
    evt.args.cancel = true;
    evt.args.displayMessage = false;
  }

  public contextMenuOpening(evt: any) {
    evt.args.cancel = true;
  }

  public close() {
    this.vtnGenerico.close();
  }

  public async guardarInf() {
    let hayCambiosOpe = false;
    let hayCambiosOC = false;
    try {
      if (ClsUtil.esNulo(this.expInsCF)) {
        await new Promise(resolve => this.tipoMsg.mostrarMsgPromise((resp) => resolve(resp), 'MENSAJES.ALERT.VALIDAR_CF_CH', undefined, 'error')).then(value => value);
        this.tabGeneral.selectedIndex = 0;
        this.tresPuntosCFA.inputCatalogos.focus();
        return;
      }
      this.tipoMsg.mostrarQuestion(async (resp: boolean) => {
        if (resp) {
          const mapExp: Map<string, ClsCatalogosExpIns> = new Map<string, ClsCatalogosExpIns>();
          let mapCatalogo: Map<string, ClsCatalogosExpIns> = new Map<string, ClsCatalogosExpIns>();
          let mapErrores: Map<string, string>;
          let mensajeError: string;
          this.tipoMsg.mostrarMasMsgsCustomizado('MENSAJES.GRALS.CH');
          this.tipoMsg.actualizarMensaje2('MENSAJES.WAIT.VALIDANDO_INF');
          this.mObjCH.mLCostoHorarios = ClsUtil.getPptoCompletoActivoMaestroJSON(this.infPpto).CostoHorarios;
          if (this.mObjCH.mLCostoHorarios.length > 0) {
            this.mObjCH.mapCodigoUnicos.set('cargofijo', this.expInsCF);
            this.mObjCH.mapCodigoUnicos.set('espera', this.expInsE);
            this.mObjCH.mapCodigoUnicos.set('reserva', this.expInsR);
            this.mObjCH.mapCodigoUnicos.set('valoradquisicion', this.expInsVA);
            // validar que no se repitan los codigos CF, E, R, VA asi mismo
            mapErrores = this.mObjCH.validarCFERVACostoHorarioParticipenAsiMismo();
            mensajeError = this.mObjCH.generarMensajeErrorCFERVACostoHorario(mapErrores, this.mObjGenerico.getTranslationsMensajes('MENSAJES.ALERT.VALIDAR_CF_E_R_VA_MISMO_CH'));
            if (mensajeError.length > 0) {
              this.tipoMsg.mostrarMsg(mensajeError);
              this.tipoMsg.cerrarMasMsgsCustomizado();
              return;
            }
            // validar CF, E, R, VA que no exista en otro CH
            mapErrores = this.mObjCH.validarCFERVACostoHorario(this.mObjCH.mLCostoHorarios, this.filaSeleccionado.IdCatalogo);
            mensajeError = this.mObjCH.generarMensajeErrorCFERVACostoHorario(mapErrores, this.mObjGenerico.getTranslationsMensajes('MENSAJES.ALERT.VALIDAR_CF_E_R_VA_CH'));
            if (mensajeError.length > 0) {
              this.tipoMsg.mostrarMsg(mensajeError);
              this.tipoMsg.cerrarMasMsgsCustomizado();
              return;
            }
          }
          this.tipoMsg.actualizarMensaje2('MENSAJES.WAIT.GUARDANDO_DATOS');
          const catExpIns = ClsUtil.getPptoCompletoActivoMaestroJSON(this.infPpto).CatExpIns;
          const allExpInsCopy: any = catExpIns.map(x => ({...x}));
          // Snapshot solo para comparar "antes" vs "después" (no va al Map)
          const allExpInsAntes: ClsCatalogosExpIns[] = allExpInsCopy.map((x) => ({ ...x }));
          mapCatalogo = ClsUtil.crearMapCatalogoCodigo(allExpInsCopy);
          try {
            // validar si hay cambios por guardar para operacion
            if (this.hasTransactionsOperacion) {
              await this.commitOperacion();
              try {
                this.mObjCostoHorario.LsCostosHorariosMO = await this.guardarGridsBD(this.gridOperacion, true, mapCatalogo, allExpInsAntes);
                await this.mObjCH.registraActualizaCostoHorario([this.mObjCostoHorario]);
              } catch (e) {
                this.restaurarGridsSiFallaAlGuardar(this.gridOperacion);
                throw new Error(e.message);
              }
              hayCambiosOpe = true;
            }
            // validar si hay cambios por guardar para otros consumos
            if (this.hasTransactionsOtroCons) {
              await this.commitOtrosCons();
              try {
                this.mObjCostoHorario.LsCostosHorariosOC = await this.guardarGridsBD(this.gridOtrosConsumos, false, mapCatalogo, allExpInsCopy);
                await this.mObjCH.registraActualizaCostoHorario([this.mObjCostoHorario]);
              } catch (e) {
                this.restaurarGridsSiFallaAlGuardar(this.gridOtrosConsumos);
                throw new Error(e.message);
              }
              hayCambiosOC = true;
            }
            this.expInsCF = this.mObjCH.generarObjCatalogoAlGuardarTodoCH(this.expInsCF, mapCatalogo, this.desCFA.value, this.tresPuntosUniCFA.valorDefault, this.costoCFA.value, this.esMoneda1);
            this.mObjCostoHorario.IdCatalogoCF = this.expInsCF.IdCatalogo;
            mapExp.set(this.expInsCF.Codigo, this.expInsCF);
            //  guardar resto de la info
            if (ClsUtil.esNulo(this.expInsE)) {
              this.mObjCostoHorario.IdCatalogoE = ClsUtil.bigintX('0');
            } else {
              this.expInsE = this.mObjCH.generarObjCatalogoAlGuardarTodoCH(this.expInsE, mapCatalogo, this.desEspera.value, this.tresPuntosUniEspera.valorDefault, this.costoEspera.value, this.esMoneda1);
              // checamo que no exista para agregarlo
              if (!mapExp.has(this.expInsE.Codigo)) {
                mapExp.set(this.expInsE.Codigo, this.expInsE);
              }
            }
            if (ClsUtil.esNulo(this.expInsR)) {
              this.mObjCostoHorario.IdCatalogoR = ClsUtil.bigintX('0');
            } else {
              this.expInsR = this.mObjCH.generarObjCatalogoAlGuardarTodoCH(this.expInsR, mapCatalogo, this.desReserva.value, this.tresPuntosUniReserva.valorDefault, this.costoReserva.value, this.esMoneda1);
              if (!mapExp.has(this.expInsR.Codigo)) {
                mapExp.set(this.expInsR.Codigo, this.expInsR);
              }
            }
            if (ClsUtil.esNulo(this.expInsVA)) {
              this.mObjCostoHorario.IdCatalogoVa = ClsUtil.bigintX('0');
            } else {
              this.expInsVA = this.mObjCH.generarObjCatalogoAlGuardarTodoCH(this.expInsVA, mapCatalogo, this.desValorAdq.value, this.tresPuntosUniValorAdq.valorDefault, this.costoValorAdq.value, this.esMoneda1);
              if (!mapExp.has(this.expInsVA.Codigo)) {
                mapExp.set(this.expInsVA.Codigo, this.expInsVA);
              }
            }
            if (ClsUtil.esNulo(this.expInsLl)) {
              this.mObjCostoHorario.IdCatalogoLla = ClsUtil.bigintX('0');
            } else {
              this.expInsLl = this.mObjCH.generarObjCatalogoAlGuardarTodoCH(this.expInsLl, mapCatalogo, this.desLlantas.value, this.tresPuntosUniLlantas.valorDefault, this.costoLlantas.value, this.esMoneda1);
              if (!mapExp.has(this.expInsLl.Codigo)) {
                mapExp.set(this.expInsLl.Codigo, this.expInsLl);
              }
            }
            if (ClsUtil.esNulo(this.expInsPE)) {
              this.mObjCostoHorario.IdCatalogoPza = ClsUtil.bigintX('0');
            } else {
              this.expInsPE = this.mObjCH.generarObjCatalogoAlGuardarTodoCH(this.expInsPE, mapCatalogo, this.desPzaEsp.value, this.tresPuntosUniPzaEsp.valorDefault, this.costoPzaEsp.value, this.esMoneda1);
              if (!mapExp.has(this.expInsPE.Codigo)) {
                mapExp.set(this.expInsPE.Codigo, this.expInsPE);
              }
            }
            if (ClsUtil.esNulo(this.expInsC)) {
              this.mObjCostoHorario.IdCatalogoComb = ClsUtil.bigintX('0');
            } else {
              this.expInsC = this.mObjCH.generarObjCatalogoAlGuardarTodoCH(this.expInsC, mapCatalogo, this.desCombustible.value, this.tresPuntosUniCombustible.valorDefault, this.costoCombustible.value, this.esMoneda1);
              if (!mapExp.has(this.expInsC.Codigo)) {
                mapExp.set(this.expInsC.Codigo, this.expInsC);
              }
            }
            if (ClsUtil.esNulo(this.expInsL)) {
              this.mObjCostoHorario.IdCatalogoAcei = ClsUtil.bigintX('0');
            } else {
              this.expInsL = this.mObjCH.generarObjCatalogoAlGuardarTodoCH(this.expInsL, mapCatalogo, this.desLubricante.value, this.tresPuntosUniLubricante.valorDefault, this.costoLubricante.value, this.esMoneda1);
              if (!mapExp.has(this.expInsL.Codigo)) {
                mapExp.set(this.expInsL.Codigo, this.expInsL);
              }
            }
            if (ClsUtil.esNulo(this.expInsOFE)) {
              this.mObjCostoHorario.IdCatalogoOtrasFuentes = ClsUtil.bigintX('0');
            } else {
              this.expInsOFE = this.mObjCH.generarObjCatalogoAlGuardarTodoCH(this.expInsOFE, mapCatalogo, this.desOtrasFEnergia.value, this.tresPuntosUniOtrasFEnergia.valorDefault, this.costoOtrasFEnergia.value, this.esMoneda1);
              if (!mapExp.has(this.expInsOFE.Codigo)) {
                mapExp.set(this.expInsOFE.Codigo, this.expInsOFE);
              }
            }
            let arrayExp: ClsCatalogosExpIns[] = [];
            mapExp.forEach((value, key) => {
              arrayExp.push(value);
            });
            // obtener el idcatalogo del EQ para actualizar el costo dependiendo de la moneda
            arrayExp.push(this.mObjCH.generarObjCatalogoAlGuardarTodoCH(this.filaSeleccionado, mapCatalogo, this.filaSeleccionado.DescripcionLarga, this.filaSeleccionado.Unidad, this.ttotalCostoActivo.value, this.esMoneda1, true));
            // guardamos en BD los registros nuevos, modificados
            arrayExp = await this.mObjCH.guardarExpIns(arrayExp, allExpInsCopy, this.mObjExpInsumos, this.socket);
            // seteeamos los id de los catalogos nuevos o existente para mandar el obj actualizado para CH
            if (!ClsUtil.esNulo(this.expInsE)) {
              this.mObjCostoHorario.IdCatalogoE = arrayExp.find(value => value.Codigo === this.expInsE.Codigo).IdCatalogo;
            }
            if (!ClsUtil.esNulo(this.expInsR)) {
              this.mObjCostoHorario.IdCatalogoR = arrayExp.find(value => value.Codigo === this.expInsR.Codigo).IdCatalogo;
            }
            if (!ClsUtil.esNulo(this.expInsVA)) {
              this.mObjCostoHorario.IdCatalogoVa = arrayExp.find(value => value.Codigo === this.expInsVA.Codigo).IdCatalogo;
            }
            if (!ClsUtil.esNulo(this.expInsLl)) {
              this.mObjCostoHorario.IdCatalogoLla = arrayExp.find(value => value.Codigo === this.expInsLl.Codigo).IdCatalogo;
            }
            if (!ClsUtil.esNulo(this.expInsPE)) {
              this.mObjCostoHorario.IdCatalogoPza = arrayExp.find(value => value.Codigo === this.expInsPE.Codigo).IdCatalogo;
            }
            if (!ClsUtil.esNulo(this.expInsC)) {
              this.mObjCostoHorario.IdCatalogoComb = arrayExp.find(value => value.Codigo === this.expInsC.Codigo).IdCatalogo;
            }
            if (!ClsUtil.esNulo(this.expInsL)) {
              this.mObjCostoHorario.IdCatalogoAcei = arrayExp.find(value => value.Codigo === this.expInsL.Codigo).IdCatalogo;
            }
            if (!ClsUtil.esNulo(this.expInsOFE)) {
              this.mObjCostoHorario.IdCatalogoOtrasFuentes = arrayExp.find(value => value.Codigo === this.expInsOFE.Codigo).IdCatalogo;
            }
            this.mObjCostoHorario.Hllantas = ClsUtil.numberX(this.vidaEconomicaHrsLlantas.value, true);
            this.mObjCostoHorario.HPiezas = ClsUtil.numberX(this.vidaEconomicaHrsPzaEsp.value, true);
            // tab cargo fijo
            this.mObjCostoHorario.Ve = ClsUtil.numberX(this.cfVidaEconomicaHrs.value, true);
            this.mObjCostoHorario.Ha = ClsUtil.numberX(this.hrsTrabajadasXAnio.value, true);
            this.mObjCostoHorario.Vr = ClsUtil.numberX(this.valorRescatePor.value, true);
            if (this.esMoneda1) {
              this.mObjCostoHorario.TasaInteresMoneda1 = ClsUtil.numberX(this.tasaInteres.value);
            } else {
              this.mObjCostoHorario.TasaInteresMoneda2 = ClsUtil.numberX(this.tasaInteres.value);
            }
            this.mObjCostoHorario.S = ClsUtil.numberX(this.primaAnualProSeg.value, true);
            this.mObjCostoHorario.Q = ClsUtil.numberX(this.factorMantenimiento.value, true);
            // tab consumos
            this.mObjCostoHorario.CalculoDetallado = this.rTipoLubCom === '1';
            this.mObjCostoHorario.UnidadPotencia = this.potenciaDescripcion.value;
            this.mObjCostoHorario.Potencia = ClsUtil.numberX(this.potenciaValor.value, true);
            this.mObjCostoHorario.Foper = ClsUtil.numberX(this.factorOperacionPor.value, true);
            this.mObjCostoHorario.TipoCombustible = ClsUtil.numberX(this.rCombustible);
            this.mObjCostoHorario.CantidadCombustible = ClsUtil.numberX(this.combustibleXHora.value, true);
            this.mObjCostoHorario.Factcomb = ClsUtil.numberX(this.factorCombustible.value, true);
            this.mObjCostoHorario.FactFuentes = ClsUtil.numberX(this.factorOtrasFuentes.value, true);
            this.mObjCostoHorario.CantidadLubricante = ClsUtil.numberX(this.lubricanteXHora.value, true);
            this.mObjCostoHorario.Faceite = ClsUtil.numberX(this.factorLubricante.value, true);
            this.mObjCostoHorario.Ccarter = ClsUtil.numberX(this.carterLts.value, true);
            this.mObjCostoHorario.Horasc = ClsUtil.numberX(this.hrsCambio.value, true);
            if (this.mObjCostoHorario.CalculoDetallado) {
              this.mObjCostoHorario.CantidadCombustible = ClsUtil.numberX(this.consumoLts.value, true);
              this.mObjCostoHorario.CantidadLubricante = ClsUtil.numberX(this.totalLubricante.value, true);
            }
            // detalle
            this.mObjCostoHorario.Marca = this.marca.value;
            this.mObjCostoHorario.Modelo = this.modelo.value;
            this.mObjCostoHorario.NumSerie = this.numeroSerie.value;
            this.mObjCostoHorario.Capacidad = this.capacidad.value;
            this.mObjCostoHorario.Ubicacion = this.ubicacion.value;
            this.mObjCostoHorario.VidaUtil = this.vidaUtil.value;
            this.mObjCostoHorario.Propietario = this.propietario.value;
            this.mObjCostoHorario.Disponibilidad = this.rDisponibilidad === '1' ? 'p' : this.rDisponibilidad === '2' ? 'c' : 'a';
            await this.mObjCH.registraActualizaCostoHorario([this.mObjCostoHorario]);
            this.mObjCH.actualizarListaCH(this.mObjCostoHorario);
            this.socket.replicate({
              Type: EnumSocket.ModificarCH,
              Data: {CH: this.mObjCostoHorario, Codigo: this.filaSeleccionado.Codigo}
            });
            // validar si la hoja es diferente, si es distinto subir el nuevo
            const nombreArchivo = `${this.docSelec.Documento}${this.docSelec.Extension}`;
            const idPpto: bigint = ClsUtil.getPptoSelectedActivoMaestro(this.infPpto).IdPresupuesto;
            if (this.docSelec.ContenidoBase64 !== this.contenidoDocCH || this.nombreDoc !== nombreArchivo) {
              // borrar anterior
              await this.mObjGenerico.borrarArchivosStorage(this.gNomBocketPpto, `${idPpto}/${this.gNomPrefixPptoCH}/${this.nombreDoc}`);
              // subir nuevo
              await this.mObjGenerico.subirArchivosStorage(EnumTipoParametro.Presupuesto, this.gNomBocketPpto, `${this.gNomPrefixPptoCH}/${nombreArchivo}`, this.docSelec.ContenidoBase64, idPpto, this.docSelec.TipoArchivo);
              // actualizar parametros
              const paramNomLibro: ClsParametro = this.infPpto.parametrosPpto.find(para => para.Parametro === EnumParaPpto.CHNOMBRELIBROCH);
              paramNomLibro.Valor = nombreArchivo;
              await this.mObjGenerico.registraActualizaNParametros(idPpto, EnumTipoParametro.Presupuesto, [paramNomLibro]);
            }
            await this.mObjGenerico.actualizarDatosTabsAbiertosPptoActivo();
            this.close();
          } catch (e) {
            if (hayCambiosOpe) {
              this.restaurarGridsSiFallaAlGuardar(this.gridOperacion);
            }
            if (hayCambiosOC) {
              this.restaurarGridsSiFallaAlGuardar(this.gridOtrosConsumos);
            }
            this.tipoMsg.mostrarMsg(e.message);
          } finally {
            this.tipoMsg.cerrarMasMsgsCustomizado();
          }
        }
      }, this.mObjGenerico.getTranslationsSubject('MENSAJES.QUESTION.GUARDAR_CH'));
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message);
    }
  }

  public validarAntesCerrar() {
    if (this.validarDatosSinGuardarGrid()) {
      this.close();
      this.sub?.unsubscribe();
    }
  }

  private validarDatosSinGuardarGrid(): boolean {
    let resp = false;
    try {
      const operacion = this.mObjGenerico.getTranslationsSubject('MENSAJES.GRALS.CHOPERACION');
      const otrosConsumos = this.mObjGenerico.getTranslationsSubject('MENSAJES.GRALS.CHOTROSCONSUMOS');
      const cambiosGral = this.mObjGenerico.getTranslationsSubject('MENSAJES.ALERT.CAMBIOS_SIN_GUARDAR_GRAL');
      const cambioCH = this.mObjGenerico.getTranslationsSubject('MENSAJES.ALERT.CAMBIOS_SIN_GUARDAR_CH');
      if (this.hasTransactionsOperacion && this.hasTransactionsOtroCons) {
        throw new Error(cambioCH.replace('{0}', operacion).replace('{1}', otrosConsumos));
      }
      if (this.hasTransactionsOperacion) {
        throw new Error(cambiosGral.replace('{0}', operacion));
      }
      if (this.hasTransactionsOtroCons) {
        throw new Error(cambiosGral.replace('{0}', otrosConsumos));
      }
      resp = true;
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
    return resp;
  }

  public async descagarArchivoLocal() {
    try {
      this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.DESCARGANDO');
      await ExcelUtility.save(this.spreadsheet.workbook, this.docSelec.Documento);
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message);
    } finally {
      this.tipoMsg.cerrarWaitDialog();
    }
  }

  protected readonly EnumTresPuntos = EnumTresPuntos;
}
